<template>
    <div style="position: relative">
        <SJMLoading v-if="pageLoading" z-index="999"></SJMLoading>
        <div class="AllocationBoard">
            <div class="top_row">
                <div class="airlineName">{{ airlineName }}</div>
                <div class="iconGroup">
                    <span>咨询</span>
                    <el-tooltip :content="customerService.mobile" 
                                placement="top" 
                                effect="light">
                        <img src="@/assets/img/product/allocationBoard/phone_2.png"/>
                    </el-tooltip>

                    <a v-if="false"
                       :href="$pcOrMobileQQ(customerService.qq)" 
                       style="display: flex;">
                        <img src="@/assets/img/product/allocationBoard/QQ.png"/></a>
                </div>
            </div>
            <!--日历-->
            <div class="boardCalendarWrap">
                <div v-show="!calendarShow" class="calendarSwiper">
                    <div class="dateSwiper-prev dateSwiper-button"
                         @click="toPrev">
                        <i class="el-icon-arrow-left"></i>
                    </div>
                    <div class="swiper-container dateSwiper">
                        <div class="swiper-wrapper">
                            <div v-for="(item,idx) in dateList"
                                 :key="idx"
                                 :class="{
                                     'swiper-slide':true,
                                     'dateSwiper':true,
                                     'active': selectDate === $moment(Number(item.date)).format('YYYY-MM-DD'), 
                                     'green': item.type === '3',
                                     'red': item.type === '4',
                                     'today': item.type === '5',
                                     'gray': item.type === '0'
                                 }">
                                <div :style="{display: 'flex','flex-direction': 'column','align-items': 'center',width: '100%',cursor: hasBoardInOneDate(item) || item.type === '6' ? 'pointer': 'default'}"
                                     @click="() => {
                                         if(hasBoardInOneDate(item)) {
                                             selectDate = $moment(Number(item.date)).format('YYYY-MM-DD')
                                         }
                                         else if (item.type === '6') {
                                             $Alert({
                                                 msg: '待航司公布报价'
                                             })
                                         }
                                     }">
                                    <div class="dateTitle">
                                        {{
                                            $moment(Number(item.date)).format('MM-DD') + ' ' + weekdays[$moment(Number(item.date)).toDate().getDay()]
                                        }}
                                    </div>
                                    <div class="dateDetail">
                                        <div>
                                            <div v-if="['1','3'].includes(item.hardBoardType)">H:</div>
                                            <div v-if="['1','2','3'].includes(item.softBoardType)">S:</div>
                                            <div v-if="['1','2','3'].includes(item.freeBoardType)">F:</div>
                                        </div>
                                        <div style="text-align: end">
                                            <div v-if="item.hardBoardType === '1'">
                                                {{ item.hardBoard.loadedWeight + '/' + item.hardBoard.minimumWeight }}
                                            </div>
                                            <div v-else-if="item.hardBoardType === '3'">
                                                航班取消
                                            </div>
                                            <div v-if="item.softBoardType === '1'" :style="{'text-decoration': item.softBoard.deleteLine === '1' ? 'line-through' : ''}">
                                                {{ item.softBoard.loadedWeight + '/' + item.softBoard.minimumWeight }}
                                            </div>
                                            <div v-else-if="item.softBoardType === '2'">
                                                未公布报价
                                            </div>
                                            <div v-else-if="item.softBoardType === '3'">
                                                航班取消
                                            </div>
                                            <div v-if="item.freeBoardType === '1'" :style="{'text-decoration': item.freeBoard.deleteLine === '1' ? 'line-through' : ''}">
                                                {{ item.freeBoard.loadedWeight + '/' + item.freeBoard.minimumWeight }}
                                            </div>
                                            <div v-else-if="item.freeBoardType === '2'">
                                                未公布报价
                                            </div>
                                            <div v-else-if="item.freeBoardType === '3'">
                                                航班取消
                                            </div>
                                        </div>
                                    </div>
                                </div>

                            </div>
                        </div>

                    </div>
                    <div class="dateSwiper-next  dateSwiper-button"
                         @click="toNext">
                        <i class="el-icon-arrow-right"></i>
                    </div>
                </div>
                <div v-if="calendarShow && calendarDateRange.length > 0" class="calendarWrap">
                    <SJMLoading v-if="calendarLoading" z-index="999"></SJMLoading>
                    <el-calendar :range="calendarDateRange"
                                 style="width: 690px;">
                        <template slot="dateCell"
                                  slot-scope="{date}">
                            <div style="position: relative;height: 100%;">
                                <div :class="['dateCell',
                                              {
                                                  'green': getDateInfo(date) && getDateInfo(date).type === '3', 
                                                  'red': getDateInfo(date) && getDateInfo(date).type === '4',
                                                  'active': selectDate === $moment(date).format('YYYY-MM-DD'),
                                                  'gray': getDateInfo(date) && getDateInfo(date).type === '0',
                                                  'today': getDateInfo(date) && getDateInfo(date).type === '5'
                                              }]"
                                     :style="{'cursor': hasBoardInOneDate(getDateInfo(date))  || getDateInfo(date).type === '6' ? 'pointer' : 'default' }"
                                     @click="() => {
                                         if (hasBoardInOneDate(getDateInfo(date))) {
                                             selectDate = $moment(date).format('YYYY-MM-DD');
                                         }
                                         else if (getDateInfo(date).type === '6') {
                                             $Alert({
                                                 msg: '待航司公布报价'
                                             })
                                         }
                                     }">
                                    <div class="dateTitle">{{ $moment(date).format('MM-DD') }}</div>
                                    <div v-if="getDateInfo(date)" class="dateDetail">
                                        <div>
                                            <div v-if="['1','3'].includes(getDateInfo(date).hardBoardType)">
                                                H:
                                            </div>
                                            <div v-if="['1','2','3'].includes(getDateInfo(date).softBoardType)">
                                                S:
                                            </div>
                                            <div v-if="['1','2','3'].includes(getDateInfo(date).freeBoardType)">
                                                F:
                                            </div>
                                        </div>
                                        <div style="text-align: right">
                                            <div v-if="getDateInfo(date).hardBoardType === '1'">
                                                {{
                                                    getDateInfo(date).hardBoard.loadedWeight + '/' + getDateInfo(date).hardBoard.minimumWeight
                                                }}
                                            </div>
                                            <div v-else-if="getDateInfo(date).hardBoardType === '3'">
                                                航班取消
                                            </div>
                                            <div v-if="getDateInfo(date).softBoardType === '1'" :style="{'text-decoration': getDateInfo(date).softBoard.deleteLine === '1' ? 'line-through' : ''}">
                                                {{
                                                    getDateInfo(date).softBoard.loadedWeight + '/' + getDateInfo(date).softBoard.minimumWeight
                                                }}
                                            </div>
                                            <div v-else-if="getDateInfo(date).softBoardType === '2'">
                                                未公布报价
                                            </div>
                                            <div v-else-if="getDateInfo(date).softBoardType === '3'">
                                                航班取消
                                            </div>
                                            <div v-if="getDateInfo(date).freeBoardType === '1'" :style="{'text-decoration': getDateInfo(date).freeBoard.deleteLine === '1' ? 'line-through' : ''}">
                                                {{
                                                    getDateInfo(date).freeBoard.loadedWeight + '/' + getDateInfo(date).freeBoard.minimumWeight
                                                }}
                                            </div>
                                            <div v-else-if="getDateInfo(date).freeBoardType === '2'">
                                                未公布报价
                                            </div>
                                            <div v-else-if="getDateInfo(date).freeBoardType === '3'">
                                                航班取消
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <!--<div v-if="getDateInfo(date) && getDateInfo(date).type === '0'" class="overlay"></div>-->
                            </div>
                            
                        </template>
                    </el-calendar>
                </div>
                <div style="background-color: #F5F5F5;">
                    <div class="calendarBtn"
                         @click="() => {
                             calendarShow = !calendarShow;
                         }">
                        <img src="@/assets/img/product/allocationBoard/calendar.png" style="width: 32px;height: 32px;"/>
                        <div style="height: 19px;font-size: 14px;color: #707070;line-height: 19px;margin-top: 2px;">
                            {{ calendarShow ? '收起' : '展开' }}
                        </div>
                    </div>
                    <div v-if="calendarShow" 
                         style="margin-top: 20px;cursor: pointer;text-align: center;"
                         @click="() => switchDate('prev')">
                        上一页
                    </div>
                    <div v-if="calendarShow"
                         style="margin-top: 10px;margin-bottom: 10px;cursor: pointer;text-align: center"
                         @click="() => switchDate('next')">
                        下一页
                    </div>
                </div>
          
            </div>
            <!--提醒-->
            <div class="boardTips">
                <div>{{ latestTimeTips }}</div>
                <div style="height: 16px;font-size: 12px;color: #4D4D4D;line-height: 16px;display: flex;">
                    <div style="display: flex;margin-right: 11px;align-items: center;">
                        <div style="width: 20px;height: 14px;background-color: #D5BEBE;margin-right: 7px;"></div>
                        <div>未达到</div>
                    </div>
                    <div style="display: flex;align-items: center;">
                        <div style="width: 20px;height: 14px;background-color: #E9EEDE;margin-right: 7px;"></div>
                        <div>已达到</div>
                    </div>
                </div>
            </div>
            <div class="hr"></div>
            <!--缺口合计-->
            <div class="gapTotal">
                <i class="el-icon-question" 
                   style="font-size: 18px" 
                   @click="discrepancyTipsShow = true"></i>
                <div>EQ统计(已起飞)</div>
                <div v-if="discrepancyTotal.hard">
                    <span>HARD:{{ discrepancyTotal.hard }}公斤</span>
                    <img src="@/assets/img/product/allocationBoard/history.png" @click="() => {this.getUserDiscrepancyDetailsData('0');}"/>
                </div>
                <div v-if="discrepancyTotal.soft">
                    <span>SOFT:{{ discrepancyTotal.soft }}公斤</span>
                    <img src="@/assets/img/product/allocationBoard/history.png" @click="() => {this.getUserDiscrepancyDetailsData('1');}"/>
                </div>
                <!--<div v-if="discrepancyTotal.free">-->
                <!--    <span>FREE:{{ discrepancyTotal.free }}公斤</span>-->
                <!--    <img src="@/assets/img/product/allocationBoard/history.png" @click="() => {this.getUserDiscrepancyDetailsData('2');}"/>-->
                <!--</div>-->
            </div>
            <div class="portAreaWrap">
                <div style="display: flex;align-items: center">
                    <div class="portAreaBtn"
                         :style="{'background': transportFlag ? '#c6e2ff': ''}"
                         @click="transportFlag = !transportFlag">
                        <img src="@/assets/img/product/allocationBoard/earth.png"/>
                        <span>转运区</span>
                    </div>
                    <div class="showMiscellaneousFeeList"
                         @click="isShowMiscellaneousFeeListDialog = true;">
                        <span class="text">查看杂费</span>
                    </div>
                    <div class="precautionsBtn" @click="precautionsDialog = true">注意事项</div>
                    <div class="flightCode">
                        航班号: {{flightCode}}
                    </div>
                </div>
                
                <!--转运区港口-->
                <el-collapse-transition>
                    <div v-if="transportFlag" class="portAreaContainer">
                        <el-table :data="useAreaList"
                                  style="width: 100%;"
                                  :show-header="false">
                            <el-table-column width="100px">
                                <template slot-scope="scope">
                                    <div style="margin-left: 2px;font-size: 14px;color: #4D4D4D;">
                                        {{ scope.row.area }}
                                    </div>
                                </template>
                            </el-table-column>
                            <el-table-column width="86px">
                                <template slot-scope="scope">
                                    <div style="font-size: 14px;color: #4D4D4D;">
                                        {{ '+' + scope.row.costPriceDiff }}
                                    </div>
                                </template>
                            </el-table-column>
                            <el-table-column>
                                <template slot-scope="scope">
                                    <div style="display: flex;flex-wrap: wrap;">
                                        <div v-for="(item,index) in scope.row.portList"
                                             :key="index"
                                             :style="selectDate && item.closeFlag.includes($moment(selectDate).format('E'))    ? 'text-decoration: line-through' : ''"
                                             style="width: 38px;height: 19px;line-height: 19px;font-size: 14px;color: #4D4D4D;text-align: center;">
                                            {{ item.port }}
                                        </div>
                                    </div>

                                </template>
                            </el-table-column>
                        </el-table>
                    </div>
                </el-collapse-transition>
                
                <!--板明细-->
                <div class="boardDataWrap"
                     style="position: relative">
                    <SJMLoading v-if="boardLoading" z-index="999"></SJMLoading>
                    <el-tabs v-model="elTabIdx">
                        <el-tab-pane v-for="(item,idx) in boardList"
                                     :key="idx"
                                     :label="item.boardName"
                                     :name="item.boardId">
                            <div class="boardDetailWrap">
                                <div class="boardInfo">
                                    <div class="left">
                                        <div class="item">
                                            <div class="title">基价:</div>
                                            <div>￥{{ item.costPrice }}/公斤</div>
                                        </div>
                                        <div class="item">
                                            <div class="title">
                                                本板重量:
                                            </div>
                                            <div>
                                                <el-tooltip :content="`该板重量超过${item.warningWeight}，请提前报备`" 
                                                            placement="top" 
                                                            effect="light" 
                                                            :disabled="Number(item.warningWeight) <= 0 || Number(item.loadedWeight) <= Number(item.warningWeight)">
                                                    <span :class="{'red': Number(item.warningWeight) > 0 && Number(item.loadedWeight) > Number(item.warningWeight)}">{{item.loadedWeight}}</span>    
                                                </el-tooltip>
                                                <span v-if="selectDate && $moment(selectDate).isBefore($moment(new Date()),'d')">(实际)</span>
                                                / {{ item.minimumWeight }} 公斤</div>
                                        </div>
                                        <div class="item">
                                            <div class="title">打板公司</div>
                                            <el-autocomplete v-model="item.operationsCompany"
                                                             popper-class="AllocationBoard_boardDetail_operationsCompany_autocomplete"
                                                             :disabled="boardDisableEdit(item)"
                                                             :fetch-suggestions="querySearchOperationCompany"
                                                             style="width: 74px;"/>
                                        </div>
                                    </div>
                                    <div class="right">
                                        <div class="makeWaybillBtn" @click="onMakeWaybill(item)">
                                            <img src="@/assets/img/product/allocationBoard/waybill.png"/>
                                            <span>运单制作</span>
                                        </div>
                                        <el-tooltip content="合并相同日期、相同ULD板"
                                                    placement="top"
                                                    effect="light">
                                            <div v-if="['0','1'].includes(item.type)"
                                                 class="mergeBoardBtn"
                                                 @click="mergeBoardTargetId=item.boardId;mergeBoardDialog = true;">
                                                <img src="@/assets/img/product/allocationBoard/mergeBoard.png"/>
                                                <span>合并板</span>
                                            </div>
                                        </el-tooltip>
                                        
                                        <el-tooltip content="需提前一周申请" 
                                                    :disabled="item.returnBoard !== ''"
                                                    placement="top" 
                                                    effect="light">
                                            <div v-if="item.type === '1' && item.returnBoard === ''"
                                                 class="returnBoardBtn"
                                                 @click="() => {
                                                     postReturnBoardData(item.boardId)    
                                                 }">
                                                <img src="@/assets/img/product/allocationBoard/returnCargo.png"/>
                                                <span>退板申请</span>
                                            </div>
                                            <div v-else-if="item.returnBoard === '0'" class="returnBoardBtn">
                                                <span>退板申请中</span>
                                            </div>
                                            <div v-else-if="item.returnBoard === '1'" class="returnBoardBtn">
                                                <span>已退板</span>
                                            </div>
                                        </el-tooltip>
                                    </div>

                                </div>
                                <div class="boardDetail">
                                    <SJMLoading v-if="orderLoading" z-index="999"></SJMLoading>
                                    <el-table :key="item.boardName" 
                                              :data="item.orderBillList">
                                        <el-table-column label=""
                                                         align="center"
                                                         width="40px">
                                            <template slot-scope="scope">
                                                <el-checkbox v-model="scope.row.checkBoxSelected">
                                                </el-checkbox>
                                            </template>

                                        </el-table-column>
                                        <el-table-column label="运单号"
                                                         align="center"
                                                         width="90px"
                                                         prop="drCode">
                                        </el-table-column>
                                        <el-table-column label="目的港"
                                                         align="center"
                                                         width="50px">
                                            <template slot-scope="scope">
                                                <!--<el-autocomplete v-model.trim="scope.row.endPort"-->
                                                <!--                 oninput="value=value.toUpperCase()"-->
                                                <!--                 :maxlength="3"-->
                                                <!--                 popper-class="AllocationBoard_boardDetail_endPort_autocomplete"-->
                                                <!--                 :fetch-suggestions="querySearchEndPort"-->
                                                <!--                 :disabled="boardDisableEdit(item) || ['1','2'].includes(scope.row.orderStatus)"-->
                                                <!--                 style="width: 100%;border-radius: 0;"-->
                                                <!--/>-->
                                                <input :value="scope.row.endPort"
                                                       oninput="value=value.toUpperCase()"
                                                       :disabled="boardDisableEdit(item) || ['1','2'].includes(scope.row.orderStatus)"
                                                       style="box-sizing: border-box;font-size: 12px;width: 100%;border-radius: 0;height: 28px;border: 1px solid #DCDFE6;text-align: left;padding-left: 3px;line-height: 26px;"
                                                       :style="{cursor: boardDisableEdit(item) || ['1','2'].includes(scope.row.orderStatus) ? 'not-allowed' : 'auto'}"
                                                       :class="{'isDisabled': boardDisableEdit(item) || ['1','2'].includes(scope.row.orderStatus),'isAbled': true}"
                                                       :maxlength="3"
                                                       @input="e => scope.row.endPort = e.target.value"/>
                                            </template>
                                        </el-table-column>
                                        <el-table-column label="件数*"
                                                         align="center"
                                                         width="50px">
                                            <template slot-scope="scope">
                                                <template v-if="scope.row.packageWay === '1'">
                                                    <div style="margin-left: 8px;margin-right: 4px;height: 28px;border-radius: 0;border: 1px solid #DCDFE6;cursor: pointer;text-align: left;padding-left: 3px;line-height: 26px;"
                                                         :class="{'isDisabled': boardDisableEdit(item) || ['1','2'].includes(scope.row.orderStatus),'isAbled': true}"
                                                         @click="() => openBookingSizeNoteDialog(scope.row)">
                                                        {{ scope.row.pieces }}
                                                    </div>
                                                </template>
                                                <template v-else>
                                                    <el-input v-model.trim="scope.row.pieces"
                                                              oninput="value=value.replace(/[^\d]/g,'')"
                                                              :disabled="boardDisableEdit(item) || ['1','2'].includes(scope.row.orderStatus)"
                                                              style="padding-left: 8px;padding-right: 4px;height: 28px;border-radius: 0;cursor: pointer;"/>    
                                                </template>
                                            </template>
                                        </el-table-column>
                                        <el-table-column label="重量*"
                                                         align="center"
                                                         width="50px">
                                            <template slot-scope="scope">
                                                <el-input v-model.trim="scope.row.weight"
                                                          oninput="value=value.replace(/[^\d]/g,'')"
                                                          :disabled="boardDisableEdit(item) || ['1','2'].includes(scope.row.orderStatus)"
                                                          style="border-radius: 0;"/>
                                            </template>
                                        </el-table-column>
                                        <el-table-column label="体积*"
                                                         align="center"
                                                         width="58px">
                                            <template slot-scope="scope">
                                                <template v-if="scope.row.packageWay === '1'">
                                                    <div style="margin-left: 4px;margin-right: 4px;height: 28px;border-radius: 0;border: 1px solid #DCDFE6;cursor: pointer;text-align: left;padding-left: 3px;line-height: 26px;"
                                                         :class="{'isDisabled': boardDisableEdit(item) || ['1','2'].includes(scope.row.orderStatus),'isAbled': true}"
                                                         @click="() => openBookingSizeNoteDialog(scope.row)">
                                                        {{ scope.row.volume }}
                                                    </div>
                                                </template>
                                                <template v-else>
                                                    <el-input v-model.trim="scope.row.volume"
                                                              oninput="value=value.replace(/[^\d.]/g,'')"
                                                              :disabled="boardDisableEdit(item) || ['1','2'].includes(scope.row.orderStatus)"
                                                              style="padding-left: 4px;padding-right: 4px;height: 28px;border-radius: 0;cursor: pointer;"/>
                                                </template>
                                            </template>
                                        </el-table-column>
                                        <el-table-column label="托盘*"
                                                         align="center"
                                                         width="80px">
                                            <template slot-scope="scope">
                                                <div style="display: flex;align-items: center;justify-content: center;">
                                                    <el-switch v-model="scope.row.packageWay"
                                                               active-value="1"
                                                               inactive-value="0"
                                                               :disabled="boardDisableEdit(item) || ['1','2'].includes(scope.row.orderStatus)"
                                                               active-color="#13ce66"
                                                               @change="() => onPackageWaySwitch(scope.row)"></el-switch>
                                                    <span style="font-size: 12px;line-height: 19px;color: #4D4D4D;margin-left: 2px;">{{ scope.row.packageWay === '1' ? '托盘' : '散货' }}</span>
                                                </div>
                                            </template>
                                        </el-table-column>
                                        <el-table-column label="尺寸*"
                                                         align="center"
                                                         width="50px">
                                            <template slot-scope="scope">
                                                <div style="display: flex;justify-content: center;align-items: center;cursor: pointer;"
                                                     @click="() => openBookingSizeNoteDialog(scope.row)">
                                                    <img src="@/assets/img/product/allocationBoard/size.png"/>
                                                    <span :style="{'margin-left': '4px','visibility': scope.row.sizeNote.length === 0 ? 'hidden': 'visible'}">...</span>
                                                </div>
                                            </template>
                                        </el-table-column>
                                        <el-table-column label="电池"
                                                         align="center"
                                                         width="50px">
                                            <template slot-scope="scope">
                                                <el-checkbox :value="scope.row.batteryInfo.length > 0"
                                                             :disabled="boardDisableEdit(item) || ['1','2'].includes(scope.row.orderStatus)"
                                                             @change="onLithiumBatteryDialog(scope.row)"></el-checkbox>
                                            </template>
                                        </el-table-column>
                                        <el-table-column label="BUP"
                                                         align="center"
                                                         width="40px">
                                            <template slot-scope="scope">
                                                <el-checkbox :disabled="boardDisableEdit(item) || ['1','2'].includes(scope.row.orderStatus)"
                                                             :value="scope.row.bupType === '1'"
                                                             @change="() => {
                                                                 // if(item.orderBillList.length > 1) { 
                                                                 //     $Alert({
                                                                 //         msg: '该板选择了BUP，只能有一票订单'
                                                                 //     })    
                                                                 //     return;
                                                                 // }
                                                                 
                                                                 scope.row.bupType = scope.row.bupType === '1' ? '0' : '1';
                                                                 
                                                             }"
                                                />
                                            </template>
                                        </el-table-column>
                                        
                                        <el-table-column label="航程"
                                                         align="center"
                                                         width="40px">
                                            <template slot-scope="scope">
                                                <div style="display: flex;align-items: center;justify-content: center;">
                                                    <img src="@/assets/img/product/allocationBoard/flight.png"
                                                         style="cursor: pointer"
                                                         @click="() => {
                                                             if (scope.row.orderStatus === '2') {
                                                                 actualAfklcargoDrCode = scope.row.drCode.substring(0,3) + '-' + scope.row.drCode.substring(3)
                                                                 actualAfklcargoShow = true;
                                                             }
                                                             else {
                                                                 getQBItineraryInfoData(scope.row.endPort)    
                                                             }                                                             
                                                         }"/>
                                                </div>
                                            </template>
                                        </el-table-column>
                                        <el-table-column label="单价"
                                                         align="center"
                                                         width="70px">
                                            <template slot-scope="scope">
                                                <div>{{ scope.row.costPrice }}</div>
                                            </template>
                                        </el-table-column>
                                        <el-table-column label="计费重量"
                                                         width="70px"
                                                         align="center">
                                            <template slot-scope="scope">
                                                <el-tooltip effect="light"
                                                            placement="top"
                                                            :disabled="scope.row.waybillType === '1'"
                                                            content="最晚航班起飞前5小时填写，逾期填写、修改100元/票">
                                                    <el-badge is-dot
                                                              style="margin-top: 4px"
                                                              :hidden="scope.row.waybillType === '1'">
                                                        <div style="cursor: pointer"
                                                             @click="() => {
                                                                 if(!['1','2'].includes(scope.row.orderStatus)) { 
                                                                     $Alert({
                                                                         msg: '请先发送E-BOOKING'
                                                                     });
                                                                     return;    
                                                                 }
                                                 
                                                                 latestTimeWaybill = item.latestTimeWaybill;
                                                                 
                                                                 boardWaybillDialog_orderBillCode = scope.row.orderBillCode;
                                                                 boardWaybillDialog_visible = Math.random();
                                                             }">
                                                            <template v-if="scope.row.feeWeight && Number(scope.row.feeWeight) > 0">
                                                                {{scope.row.feeWeight}}<i class="el-icon-edit" style="margin-left: 4px;font-size: 10px"/>
                                                            </template>
                                                            <template v-else>
                                                                <span style="color: #F56C6C">未填写</span>
                                                            </template>
                                                        </div>
                                                    </el-badge>
                                                </el-tooltip>     
                                            </template>
                                        </el-table-column>
                                     
                                        <el-table-column label="状态"
                                                         align="center"
                                                         width="60px">
                                            <template slot-scope="scope">
                                                <div v-if="scope.row.orderStatus === '2'">已完成</div>
                                                <div v-else-if="scope.row.orderStatus === '1'">审核中</div>
                                                <div v-else></div>
                                            </template>
                                        </el-table-column>
                                        <el-table-column label="改期"
                                                         align="center"
                                                         width="40px">
                                            <template slot-scope="scope">
                                                <img src="@/assets/img/product/allocationBoard/calendar.png"
                                                     style="width: 16px;height: 16px;vertical-align: middle;cursor: pointer" 
                                                     @click="() => {
                                                         if (['1','2'].includes(scope.row.orderStatus)) {
                                                             $Alert({
                                                                 msg: '已发送E-Booking，不能改期，请联系客服改期'
                                                             })
                                                             return;
                                                         }  
                                                         changeDateDialog.orderBill = scope.row;
                                                         changeDateDialog.dateStr = '';
                                                         changeDateDialog.errMsg = '';
                                                         changeDateDialog.selectDate = selectDate;
                                                         changeDateDialog.boardList = [];
                                                         changeDateDialog.visible = true;
                                                         getPackageBoardRescheduleData();
                                                         
                                                     }"/>
                                            </template>
                                        </el-table-column>
                                        <el-table-column label="托书"
                                                         align="center"
                                                         width="40px">
                                            <template slot-scope="scope">
                                                <a :href="`/personalCenter/operationCenter/cargoQuery/exportBusiness/OrderInfo?orderBillCode=${scope.row.orderBillCode}`"
                                                   target="_blank">
                                                    <img src="@/assets/img/product/allocationBoard/document.png"
                                                         style="width: 16px;height: 16px;vertical-align: middle;cursor: pointer"/>
                                                </a>
                                            </template>
                                        </el-table-column>
                                        <el-table-column label="账单"
                                                         align="center"
                                                         width="50px">
                                            <template slot-scope="scope">
                                                <img v-if="scope.row.orderStatus === '2'" 
                                                     src="@/assets/img/product/allocationBoard/bill.png"
                                                     style="width: 16px;height: 16px;vertical-align: middle;cursor: pointer"
                                                     @click="viewBills(scope.row.orderBillCode)"/>
                                        
                                            </template>
                                        </el-table-column>
                                        
                                        <el-table-column label="删除"
                                                         align="center"
                                                         width="50px">
                                            <template slot-scope="scope">
                                                <img src="@/assets/img/product/allocationBoard/delete.png"
                                                     style="width: 16px;height: 16px;vertical-align: middle;cursor: pointer;"
                                                     @click="() => {
                                                         if ('1' === scope.row.orderStatus) {
                                                             $Alert({
                                                                 msg: '审核中不能删除'
                                                             })
                                                             return;
                                                         }
                                                         if (['1','2'].includes(scope.row.orderStatus)) {
                                                             postPackageBoardCancelEbookingData(item.boardId,scope.row.orderBillCode);
                                                         }
                                                         else {
                                                             postDeleteBoardOrderData(item.boardId,scope.row.orderBillCode);   
                                                         }
                                                                 
                                                     }">
                                            </template>
                                        </el-table-column>
                                    </el-table>
                                </div>
                                <div class="boardReduce">
                                    <div class="reduceInfo">
                                        <el-button icon="el-icon-plus"
                                                   type="text"
                                                   size="medium"
                                                   style="width: 60px;"
                                                   @click="() => addOrder(idx)"
                                        >添加
                                        </el-button>
                                        <div style="width: 60px;text-align: center;margin-left: 108px;font-size: 13px;">
                                            {{ item.piecesTotal }}件
                                        </div>
                                        <div style="width: 50px;text-align: center;font-size: 13px;">{{ item.weightTotal }}公斤</div>
                                        <div style="width: 90px;text-align: center;font-size: 13px;">{{ item.volumeTotal }}立方</div>
                                        <div style="width: 90px;text-align: center;margin-left: 268px;font-size: 13px;">{{ item.feeWeightTotal }}公斤</div>
                                    </div>
                                    <div>
                                        <el-button type="primary"
                                                   style="width: 80px;height: 32px;"
                                                   @click="() => postSaveBoardAllocationData(item)">
                                            保存
                                        </el-button>
                                    </div>
                                </div>
                                <div class="tips">
                                    <div>*填写实际入库数据</div>
                                    <div>*货物500公斤以上需填写尺寸、货物体积3个方以上需填写尺寸、托盘需填写尺寸</div>
                                    
                                </div>
                                <div class="latestTimeTips">
                                    最晚{{
                                        $moment(Number(item.latestTime)).format('MM-DD') + ' ' + weekdays[$moment(Number(item.latestTime)).format('e')] + ' ' + $moment(Number(item.latestTime)).format('HH:mm')
                                    }}
                                    前 发送 E-BOOKING
                                </div>
                                <div class="ebookingArea">
                                    <div v-if="item.ebookingTimeType === '2'">
                                        <div style="color: #FF0000">超时</div>
                                    </div>
                                    <div v-if="item.ebookingTimeType === '1'" class="countdownGroup">
                                        还剩
                                        <div class="countdown">{{ countdownRenderer(item.ebookingLastTime).h }}</div>
                                        <span class="colon">小时</span>
                                        <div class="countdown">{{ countdownRenderer(item.ebookingLastTime).m }}</div>
                                        <span class="colon">分钟</span>
                                    </div>
                                    <el-button type="primary"
                                               size="middle"
                                               @click="() => {
                                                   $Confirm({
                                                       msg: 'E-BOOKING发送后不能修改，是否继续？',
                                                       callback: () => {
                                                           postPackageBoardSendEbookingData(item)    
                                                       }
                                                   })
                                                           
                                               }">E-BOOKING
                                    </el-button>
                                </div>
                            </div>
                        </el-tab-pane>
                    </el-tabs>

                </div>


            </div>
        </div>
        
        <!--缺口明细-->
        <el-dialog title=""
                   :visible.sync="gapVisible"
                   width="800px">
            <SJMLoading v-if="gapLoading" z-index="999"></SJMLoading>
            <div class="gapDetailDialog">
                <div class="title">
                    <div v-if="gapIdx === '0'">HARD板</div>
                    <div v-else-if="gapIdx === '1'">SOFT板</div>
                    <div v-else-if="gapIdx === '2'">FREE板</div>
                </div>
                <div class="detail">
                    <el-table :key="gapIdx" :data="userDateRangeList">
                        <el-table-column type="expand">
                            <template slot-scope="scope">
                                <div v-for="(item,index) in scope.row.discrepancyList" 
                                     :key="index"
                                     style="display: flex;height: 16px;font-size: 12px;color: #4D4D4D;line-height: 16px;">
                                    <div style="width: 25%;text-align: right;">
                                        {{ $moment(Number(item.date)).format('MM.DD') }}
                                    </div>
                                    <div style="width: 39%;text-align: right;">
                                        <template v-if="scope.row.type === '0'">
                                            {{ item.loadedWeight + '/' + item.minimumWeight }}    
                                        </template>
                                        <template v-else>
                                            补缺口
                                        </template>
                                        
                                    </div>
                                    <div :class="{'red': Number(item.discrepancy) > 0, 'green': Number(item.discrepancy) < 0}" style="width: 32%;text-align: right;">
                                        {{ Number(item.discrepancy) >= 0 ? '+' : '' }}{{ item.discrepancy }}
                                    </div>
                                </div>
                            </template>
                        </el-table-column>
                        <el-table-column label="日期区间"
                                         align="center"
                                         class-name="columnClass"
                                         prop="date">
                            <template slot-scope="scope">
                                {{ scope.row.dateRange }}
                            </template>
                        </el-table-column>
                        <el-table-column label="实际重量/最少重量"
                                         align="center"
                                         class-name="columnClass">
                            <template slot-scope="scope">
                                <template v-if="scope.row.type === '0'">
                                    {{ scope.row.loadedWeight + '/' + scope.row.minimumWeight }}
                                </template>
                                <template v-else>
                                    <span style="margin-right: -80px">补缺口</span>
                                </template>
                            </template>
                        </el-table-column>
                        <el-table-column label="EQ增减"
                                         align="center"
                                         class-name="columnClass"
                                         prop="discrepancy">
                            <template slot-scope="scope">
                                <div :class="{'red': Number(scope.row.discrepancy) > 0, 'green': Number(scope.row.discrepancy) < 0}">
                                    {{ Number(scope.row.discrepancy) >= 0 ? '+' : '' }}{{ scope.row.discrepancy }}
                                </div>
                            </template>
                        </el-table-column>
                    </el-table>

                </div>
                <div class="reduce">
                    {{ '合计：' + userDiscrepancyTotal }}
                </div>
            </div>
            

        </el-dialog>

        <!-- 尺寸备注弹框 -->
        <el-dialog
                :visible.sync="sizeRemarkIsShow"
                :show-close="false"
                :close-on-press-escape="false"
                class="sizeRemarkDialog"
                width="575px">

            <div class="sizeNoteWrapper">
                <div class="sizeNote">
                    <div style="margin-right: 20px;width: 60px;text-align: center;">数量</div>
                    <div style="width: 60px;text-align: center;">长(cm)</div>
                    <div style="width: 60px;text-align: center;">宽(cm)</div>
                    <div style="width: 60px;text-align: center;">高(cm)</div>
                </div>
                <div v-for="(item,index) in sizeNoteList"
                     :key="index"
                     class="sizeNote">
                    <input v-model.trim="item.pieces"
                           type="text"
                           style="margin-right: 20px;"
                           :disabled="orderSizeNoteObj && ['1','2'].includes(orderSizeNoteObj.orderStatus)"
                           class="sizeNoteInput"/>
                    <input v-model.trim="item.length"
                           type="text"
                           :disabled="orderSizeNoteObj && ['1','2'].includes(orderSizeNoteObj.orderStatus)"
                           class="sizeNoteInput"/>
                    <input v-model.trim="item.width"
                           type="text"
                           :disabled="orderSizeNoteObj && ['1','2'].includes(orderSizeNoteObj.orderStatus)"
                           class="sizeNoteInput"/>
                    <input v-model.trim="item.high"
                           type="text"
                           :disabled="orderSizeNoteObj && ['1','2'].includes(orderSizeNoteObj.orderStatus)"
                           class="sizeNoteInput"/>
                    <div class="deleteOperate" @click="deleteSizeNote(index)">
                        <i class="el-icon-delete"></i>
                    </div>
                </div>

                <div class="sizeNoteAdd" @click="addSizeNote">
                    <i class="el-icon-plus"></i>
                    <div style="font-size: 14px;margin-left: 9px">添加</div>
                </div>
                
                <div class="sizeNoteEnter">
                    <el-button size="small" @click="sizeNoteEnter">确定</el-button>
                </div>
            </div>

        </el-dialog>
        
        <!--QB订舱-->
        <el-dialog :visible.sync="QBItineraryInfoShow"
                   class="QBSecondPassInformation"
                   width="630px"
        >
            <SJMLoading v-if="QBItineraryInfoLoading" z-index="999"></SJMLoading>
            <div v-if="QBItineraryInfoShow" id="QBSecondPassInformation">
                <div id="QBInfoHead">
                    <div id="QBInfoHead_left">
                        <div id="QBInfoHead_div1">
                            <div id="QBInfoHead_div1_departureTime" class="firsttitle">
                                {{ QBItineraryInfo.departureTime }}
                            </div>
                            <div id="QBInfoHead_div1_startport" style="color: #b3b3b3;font-size: 12px;">
                                {{ startPort }}
                            </div>
                        </div>
                        <div id="QBInfoHead_div2">
                            <div v-if="QBItineraryInfo.stop === ''">
                                <div id="QBInfoHead_div2_stop" class="firsttitle">
                                    直达
                                </div>
                            </div>
                            <template v-else>
                                <div id="QBInfoHead_div2_stop" class="firsttitle">
                                    {{ QBItineraryInfo.stop }}中转
                                </div>
                                <div id="QBInfoHead_div2_stopTime"
                                     style="color: #b3b3b3;font-size: 12px;text-align: center;">
                                    停留{{ QBItineraryInfo.stopTime }}
                                </div>
                            </template>

                        </div>
                        <div id="QBInfoHead_div3">
                            <div id="QBInfoHead_div3_arrivalTime" class="firsttitle">
                                {{ QBItineraryInfo.arrivalTime }}
                            </div>
                            <div id="QBInfoHead_div3_endport"
                                 style="text-align: center;color: #b3b3b3;font-size: 12px;">
                                {{ QBItineraryInfo.endPort }}
                            </div>
                        </div>
                        <div id="QBInfoHead_div4">
                            <div id="QBInfoHead_div4_flightDuration"
                                 class="firsttitle"
                                 style="color: #0097E0">
                                预计全程{{ QBItineraryInfo.flightDuration }}到达
                            </div>
                        </div>
                    </div>
                    <div id="QBInfoHead_right">
                        
                    </div>
                </div>
                <div id="QBInfoBody">
                    <div id="QBInfoBody_title">行程详情</div>
                    <div id="QBInfoBody_flightDetails">
                        <div v-for="(item,index) in QBItineraryInfo.flightDetails"
                             :key="index"
                             class="QBInfoBody_flightDetail">
                            <div class="QBInfoBody_flightDetail_div1">
                                <div class="QBInfoBody_flightDetail_div1_port">
                                    {{ item.startPort + ' - ' + item.destination }}
                                </div>
                                <div class="QBInfoBody_flightDetail_div1_flight">
                                    <img v-if="item.transportType === '0'"
                                         src="@/assets/img/product/allocationBoard/small_flight.png"/>
                                    <img v-if="item.transportType === '1'"
                                         src="@/assets/img/product/allocationBoard/small_car.png"/>

                                    <span style="margin-left: 5px">{{ item.flightNumber }}</span>
                                    <span v-if="item.transportType === '0'">(飞机)</span>
                                    <span v-if="item.transportType === '1'">(卡车)</span>
                                </div>
                                <div class="QBInfoBody_flightDetail_div1_startTime_endTime">
                                    {{ item.startTime + ' - ' + item.endTime }}
                                </div>
                            </div>
                            <div class="QBInfoBody_flightDetail_div2_status">
                                {{ item.status }}
                            </div>
                            <div class="QBInfoBody_flightDetail_div3_stopInfo">
                                {{ item.stopInfo }}
                            </div>
                        </div>
                    </div>
                </div>
                

            </div>
        </el-dialog>
        <el-dialog :visible.sync="actualAfklcargoShow"
                   class="actualAfklcargoInformation"
                   width="800px">
            <div v-if="actualAfklcargoShow" 
                 class="iframeWrap">
                <iframe ref="iframe"
                        :src="actualAfklcargoUrl + actualAfklcargoDrCode"
                        frameborder="0"
                        width="100%"></iframe>

            </div>
        </el-dialog>
        
        <!--查看杂费清单-->
        <el-dialog title="查看杂费清单"
                   :visible.sync="isShowMiscellaneousFeeListDialog"
                   width="490px"
                   custom-class="miscellaneousFeeListDialog"
                   :show-close="!miscellaneousFeeListLoading"
                   :close-on-press-escape="false"
                   :close-on-click-modal="false">
            <div class="miscellaneousFeeListWrap">
                <el-table :data="airlinesFeeList">
                    <el-table-column prop="feeName"
                                     align="center"
                                     label="费用名称">
                    </el-table-column>
                    <el-table-column prop="unitPrice"
                                     align="center"
                                     label="单价">
                        <template slot-scope="scope">
                            <span>¥ {{scope.row.unitPrice}}</span>
                        </template>
                    </el-table-column>
                    <el-table-column prop="billingMethod"
                                     align="center"
                                     label="计费方式">
                        <template slot-scope="scope">
                            {{billingMethodList[scope.row.billingMethod]}}
                        </template>
                    </el-table-column>
                    <el-table-column prop="remark"
                                     align="center"
                                     label="备注">
                    </el-table-column>
                </el-table>
                <div class="btnBox">
                    <el-button type="primary" @click="isShowMiscellaneousFeeListDialog = false;">确定</el-button>
                </div>
                <SJMLoading v-if="miscellaneousFeeListLoading" z-index="999"></SJMLoading>
            </div>
        </el-dialog>

        <el-dialog title="账单"
                   custom-class="actualCostConfirm"
                   :visible.sync="actualBillShow">
            <div v-if="actualBillShow" id="costConfirm">
                <div class="costConfirmBd">
                    <div class="billGroup">
                        <!--实际账单-->
                        <div class="realBill billGroupItem">
                            <div class="itemHd">
                                <span class="title">{{ $t('message.realBill') }}</span>
                                <span style="font-size: 12px;margin-left: 5px;">(起飞后显示空运费)</span>
                            </div>
                            <div class="itemBd">
                                <el-table
                                        size="medium"
                                        :data="realBill.billList"
                                        class="billList"
                                        style="width: 100%;">
                                    <el-table-column
                                            :label="$t('message.bookingCost')"
                                            prop="feeName"
                                            align="center">
                                    </el-table-column>
                                    <el-table-column
                                            :label="$t('message.unitPrice')"
                                            align="center">
                                        <template slot-scope="scope">
                                            {{ $currencyAbbr(currencyType) }}{{ scope.row.settleUnitPrice }}
                                        </template>
                                    </el-table-column>
                                    <el-table-column
                                            :label="$t('message.quantity')"
                                            prop="settleCount"
                                            align="center">
                                    </el-table-column>
                                    <el-table-column
                                            :label="$t('message.amount')"
                                            align="center">
                                        <template slot-scope="scope">
                                            {{ $currencyAbbr(currencyType) }}{{ scope.row.totalAmount }}
                                        </template>
                                    </el-table-column>
                                </el-table>
                                <div class="tableBg"></div>
                                <div class="tableFt">
                                    <div class="total">
                                        <div class="totalBody">
                                            <span>{{ $t('message.summation') }}{{ $t('message.$colon') }}</span>
                                            <span class="money">{{ $currencyAbbr(currencyType) }}{{
                                                realBill.total
                                            }}</span>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="costConfirmFt">
                    <el-collapse-transition>
                        <div v-if="submitInvoiceMod && realBill.billList.length > 0" id="submitInvoice">
                            <div class="submitInvoiceHd">
                                <div class="isSubmitInvoice">{{ $t('message.submitBilling') }}</div>
                                <div class="inputGroup">
                                    <!-- 开票类型 -->
                                    <div v-if="$overseasType" class="invoiceRadioGroup">
                                        <div class="invoiceTypeBtn selected">
                                            DEBIT NOTE
                                        </div>
                                    </div>
                                    <template v-else>
                                        <div class="invoiceRadioGroup">
                                            <div class="invoiceTypeBtn"
                                                 :class="{selected: invoiceRadio === '2', disabled: invoiceTypeBtnIsDisabled('2') || (invoiceModify === '0' && invoiceRadio !== '2')}"
                                                 @click="invoiceTypeRadioChange('2')">
                                                {{ electronInvoiceText }}
                                                <span class="iconfont icon-tuijian"></span>
                                            </div>
                                            <div class="invoiceTypeBtn"
                                                 :class="{selected: invoiceRadio === '0', disabled: invoiceTypeBtnIsDisabled('0') || (invoiceModify === '0' && invoiceRadio !== '0')}"
                                                 @click="invoiceTypeRadioChange('0')">
                                                DEBIT NOTE
                                            </div>
                                            <div v-show="paperInvoiceMod"
                                                 class="invoiceTypeBtn paperInvoice"
                                                 :class="{selected: invoiceRadio === '1', disabled: invoiceTypeBtnIsDisabled('1')}"
                                                 @click="invoiceTypeRadioChange('1')">
                                                {{ invoiceText }}
                                                <p class="paperInvoiceModTip">{{ $t('message.paperInvoiceModTip') }}</p>
                                            </div>
                                            <span v-show="expandMoreMod"
                                                  class="expandMore"
                                                  @click="expandMoreClick">{{ $t('message.expandMore') }}</span>
                                        </div>
                                        <!-- 付款抬头信息 -->
                                        <el-collapse-transition>
                                            <p v-if="invoiceRadio === '2'" class="payTitle">
                                                <span>电票付款抬头：上海久茂国际物流有限公司</span>
                                                <span>银行账户：216140100100236536</span>
                                                <span>开户行：兴业银行上海华山支行</span>
                                            </p>
                                        </el-collapse-transition>
                                        <!-- 自动核销 -->
                                        <!-- <div v-if="preInvoicing === '1'" class="autoWriteOff">
                                            <span class="title">{{$t('message.autoWriteOff')}}</span>
                                            <el-switch v-model="autoWriteOff"
                                                       class="autoWriteOffSwitch"
                                                       active-value="1"
                                                       inactive-value="0"></el-switch>
                                            <span class="autoWriteOffTips">{{$t('message.autoWriteOffTips')}}</span>
                                        </div> -->
                                        <!-- 合并开票 月结 + 提交时非DEBIT NOTE和空 -->
                                        <div v-if="confirmFeeData.settlementMethod === '0' && !['', '0'].includes(invoiceRadio)"
                                             class="invoiceMergeBox">
                                            <span class="invoiceMergeBoxTitle">{{ $t('message.billingStatus') }}</span>
                                            <el-radio v-model="invoiceMerge"
                                                      label="1"
                                                      :disabled="isNoChoice">{{ $t('message.mergeInvoice') }}
                                            </el-radio>
                                            <el-radio v-model="invoiceMerge"
                                                      label="0"
                                                      :disabled="isNoChoice"
                                                      @change="independentInvoiceRadioSel">
                                                {{ $t('message.independentInvoice') }}
                                            </el-radio>
                                        </div>
                                        <!-- 电子发票提醒 -->
                                        <ul class="electronInvoiceTips">
                                            <li>{{ $t('message.aboutElectronicInvoiceTit') }}</li>
                                            <li>{{ $t('message.aboutElectronicInvoice1') }}</li>
                                            <li>{{ $t('message.aboutElectronicInvoice2') }}</li>
                                            <li>{{ $t('message.aboutElectronicInvoice3') }}</li>
                                            <li>{{ $t('message.aboutElectronicInvoiceTip') }}</li>
                                        </ul>
                                    </template>
                                </div>
                                <div v-if="invoiceLimit==='2'" class="beforeNotInvoicePromptBox">
                                    {{ $t('message.beforeNotInvoicePrompt') }}
                                </div>
                                <div v-else-if="invoiceLimit==='3'" class="overtakeTenDayNotInvoicePromptBox">
                                    您存在当月托单完成后超过10天未开票的数据，请先完成后再提交本次操作。有特殊情况请联系客服处理。
                                </div>
                            </div>
                            <template v-if="['0','1'].includes(invoiceLimit)">
                                <el-collapse-transition>
                                    <div v-if="submitInvoiceBdMod" class="submitInvoiceBd">
                                        <div id="invoiceInfo">
                                            <div class="invoiceInfoHd">
                                                <span class="invoiceName">{{ $t('message.invoiceName') }}</span>
                                                <el-select v-model="invoiceInfoIndex"
                                                           size="mini"
                                                           :disabled="invoiceModify === '0'"
                                                           @change="invoiceTitSelect(invoiceInfoIndex)">
                                                    <el-option
                                                            v-for="(item,index) in invoiceInfoList"
                                                            :key="index"
                                                            :label="item.title"
                                                            :value="index">
                                                    </el-option>
                                                </el-select>
                                            </div>
                                            <div v-if="invoiceRadio === '2'" class="financialMailbox">
                                                <label for="">{{ $t('message.financialMailbox') }}</label>
                                                <el-input id="invoice_Info_financialMailbox"
                                                          v-model="financialMail"
                                                          type="text"
                                                          size="mini"
                                                          :placeholder="$t('message.pleaseEnterEmail')"></el-input>
                                                <span class="financialMailTip">{{ $t('message.emailCanModified') }}</span>
                                            </div>

                                            <div class="invoiceInfoBd">
                                                <ul id="invoiceInfoDetail">
                                                    <li v-for="(item,key,index) in invoiceInfoItemData"
                                                        v-show="index<8&&(index<5||invoiceRadio=== '1')"
                                                        :key="index"
                                                        class="infoItem">
                                                        <label class="invoiceInfoItemLabel">{{ invoiceInfoDetailTextArr[index] }}</label>
                                                        <el-input id="invoice_Info_title"
                                                                  v-model="invoiceInfoItemData[key]"
                                                                  disabled
                                                                  size="mini"></el-input>
                                                    </li>
                                                </ul>
                                            </div>
                                        </div>
                                    </div>
                                </el-collapse-transition>
                                <el-collapse-transition>
                                    <div v-if="submitInvoiceFtMod" class="submitInvoiceFt">
                                        <el-button v-if="confirmAndSubmit"
                                                   type="primary"
                                                   size="mini"
                                                   @click="confirmAndSubmitClick();">
                                            {{ $t('message.confirmFeeAndSubmitInvoice') }}
                                        </el-button>
                                    </div>
                                </el-collapse-transition>
                                <el-collapse-transition>
                                    <div v-if="invoiceHintsMod" class="invoiceHints">
                                        <p>{{ $t('message.invoiceHint1') }}</p>
                                        <p>{{ $t('message.invoiceHint2') }}</p>
                                    </div>
                                </el-collapse-transition>
                            </template>
                        </div>
                    </el-collapse-transition>

                </div>
                <!--加载中-->
                <SJMLoading v-if="isShowLoading"
                            zIndex="999"
                            top="300px"></SJMLoading>

            </div>
        </el-dialog>

        <el-dialog title=""
                   :visible.sync="discrepancyTipsShow"
                   width="700px">
            <div style="line-height: 28px;font-size: 18px;color: #4D4D4D;">
                <div>
                    EQ=Equalization
                </div>
                <div>
                    Q5 Pivot 2750KG 在规定时间内总EQ值未达到2750KG，缺少部分航司会开罚金。
                </div>
                <div>
                    不同ULD板独立统计。
                </div>
                <div>
                    周期：1日至15日、16日至月底。
                </div>
            </div>
            
        </el-dialog>
        
        <!--合并板-->
        <el-dialog title="合并板"
                   :visible.sync="mergeBoardDialog"
                   width="320px" >
            <div class="mergeBoardDialog">
                <div class="row1">
                    <el-select v-model="mergeBoardSourceId" style="width: 125px">
                        <el-option v-for="item in mergeBoardList"
                                   :key="item.value"
                                   :label="item.label"
                                   :value="item.value">
                        </el-option>
                    </el-select>
                    <img src="@/assets/img/product/smartProducts/startEndPortSmall.png"/>
                    <div>当前板</div>
                </div>
                <div class="buttonGroup">
                    <el-button style="width: 68px;height: 30px;border: 1px solid #4D4D4D;border-radius: 4px;" @click="postMergeBoardData">合并</el-button>
                </div>
                <SJMLoading v-if="mergeBoardDialogLoading" z-index="999"></SJMLoading>
            </div>
        </el-dialog>

        <!--锂电池-->
        <el-dialog :visible.sync="lithiumBatteryDialog"
                   width="600px">
            <div class="lithiumBatteryDialog">
                <div class="title">含锂电池</div>
                <div class="content">
                    <el-checkbox v-model="lithiumBatteryDialogObj.PI965">PI965（整票货也只有锂电池 ）</el-checkbox>
                    <el-checkbox v-model="lithiumBatteryDialogObj.PI966">PI966（器材与锂电池分开摆放在同一盒子内）</el-checkbox>
                    <el-checkbox v-model="lithiumBatteryDialogObj.PI967">PI967（锂电池已经装嵌好在器材上面，如I-PHONE）</el-checkbox>
                    <el-checkbox v-model="lithiumBatteryDialogObj.PI969">PI969（锂金属电池，器材与锂电池分开摆放在同一盒子内）</el-checkbox>
                    <el-checkbox v-model="lithiumBatteryDialogObj.PI970">PI970（锂电池已经装嵌好在器材上面，不可取出）</el-checkbox>
                </div>
                <el-button @click="saveLithiumBatteryDialog">确定</el-button>
            </div>
        </el-dialog>
        
        <el-dialog :visible.sync="precautionsDialog" title="2C包板订单注意事项">
            <div class="precautionsDialog">
                <div>预报数据截止时间为：开航日前2天12点截止，另周日和周一航班截止时间为前一周五的12点前。</div>
                <div>实际数据截止时间为：开航日前1天12点截止。</div>
                <div>上传主分仓单时间：开航日前1天16点截止。</div>
                <div>发送天运通截止时间：开航日前1天17点截止。</div>
                <div>交货截止时间：开航日前1天晚上22：30前交板交单。</div>
                <div class="btnBox">
                    <el-button type="primary" @click="precautionsDialog = false;">确定</el-button>
                </div>
            </div>

        </el-dialog>
        
        <!--改期-->
        <el-dialog :visible.sync="changeDateDialog.visible" 
                   :close-on-click-modal="false"
                   :close-on-press-escape="false"
                   center
                   title="改期" 
                   width="453px">
            <div class="changeDateDialog">
                <div class="row1">
                    <el-date-picker v-model="changeDateDialog.selectDate" 
                                    style="width: 140px"
                                    type="date" 
                                    placeholder="选择日期" 
                                    :picker-options="changeDateDialog.pickerOptions"
                                    @change="() => {
                                        if(changeDateDialog.selectDate != null) { 
                                            getPackageBoardRescheduleData();
                                        }
                                    }"></el-date-picker>
                    <el-button style="margin-left: 20px" 
                               size="mini" 
                               type="primary" 
                               @click="getPackageBoardRescheduleData">查询</el-button>
                </div>
                <div class="row2">
                    <SJMLoading v-if="changeDateDialog.loading"></SJMLoading>
                    <div class="dateTitle">{{changeDateDialog.dateStr}}</div>
                    <div v-if="changeDateDialog.errMsg" class="errMsg">{{changeDateDialog.errMsg}}</div>
                    <div v-else class="boardList">
                        <div v-for="(item,index) in changeDateDialog.boardList" 
                             :key="index" 
                             class="boardWrap">
                            <div class="boardName">{{item.boardName}}</div>
                            <div class="weightData">{{item.loadedWeight + '/' +item.minimumWeight}}</div>
                            <el-button class="moveButton" 
                                       size="mini" 
                                       style="width: 64px;padding: 0;text-align: center;height: 24px;"
                                       type="primary" 
                                       :disabled="item.currentBoard"
                                       @click="postPackageBoardRescheduleData(index)">{{item.currentBoard ? '已在此板' : '移往此板'}}</el-button>
                        </div>
                    </div>
                </div>
            </div>
        </el-dialog>    
        
        
        
        <BoardWaybillDialog :is-over-board-date5-day="isOverBoardDate5Day" 
                            :latest-time-waybill="latestTimeWaybill" 
                            :order-bill-code="boardWaybillDialog_orderBillCode" 
                            :visible="boardWaybillDialog_visible"/>
        <PackageBoardProtocol :show="packageBoardProtocolDialogShow" :protocol-url="protocolUrl"/>
    </div>
</template>
<script>
    import PackageBoardProtocol from '@/components/personalCenter/importBusiness/PackageBoardProtocol.vue';
    import BoardWaybillDialog from '@/components/BoardWaybillDialog.vue';

    export default {
        name: 'AllocationBoard',
        components: {BoardWaybillDialog, PackageBoardProtocol},
        data() {
            return {
                // 包装方式
                packageMethodList: [
                    {value: '木托'},
                    {value: '木托有标'},
                    {value: '木托无标'},
                    {value: '塑托'},
                    {value: '夹板托'},
                    {value: '夹板箱'},
                    {value: '木箱有标'},
                    {value: '木箱无标'},
                    {value: '编织袋'},
                    {value: '布卷'},
                    {value: '塑料桶'},
                    {value: '其它'},
                    {value: '挂衣'},
                    {value: '纸托'},
                    {value: '铁托'},
                    {value: '铁桶'},
                    {value: '纸筒'},
                    {value: '塑料托盘'},
                    {value: '塑料箱'},
                    {value: '夹板托盘'},
                    {value: '夹板箱子'},
                    {value: '木箱'},
                    {value: '木屑托'},
                    {value: '木筐'},
                    {value: '木筐有标'},
                    {value: '木筐无标'},
                    {value: '挂衣箱'},
                    {value: '纸托盘'},
                    {value: '铁托盘'},
                    {value: '纸箱'},
                    {value: '纸盒'},
                    {value: '泡沫箱'},
                    {value: '泡沫托'},
                    {value: '金属托'},
                    {value: '金属箱'},
                    {value: '金属筐'},
                    {value: '托盘'},
                    {value: '纸桶'},
                    {value: '塑料托'},
                    {value: '木托夹板箱'},
                    {value: '行李箱'},
                ],
                baseUrl: process.env.BASE_URL, // baseUrl
                mySwiper: null,
                mySwiperOption: {
                    slidesPerView: 7,
                    noSwiping: true,
                    simulateTouch: false,
                },
                dateList: [],
                weekdays: ['周日', '周一', '周二', '周三', '周四', '周五', '周六'],
                transportFlag: false,
                pageLoading: false,
                calendarShow: false,
                calendarLoading: false,
                orderLoading: false,
                elTabIdx: '',

                calendarDateRange: [],
                airline: '',
                airlineName: '', // 航司名称
                productNo: '', // 产品编号
                startPort: '',// 起始港
                latestTimeTips: '', // 最晚配板时间提示
                // 缺口合计
                discrepancyTotal: {
                    hard: '', // HARD板缺口合计（无返回空字符串）
                    soft: '', // SOFT板缺口合计（无返回空字符串）
                    free: '', // FREE板缺口合计（无返回空字符串）
                },
                // 客服
                customerService: {
                    mobile: '',// 手机
                    qq: '',// qq
                },
                operationsCompanyHistory: [],// 历史打板公司列表
                packageBoardProtocol: '0',// 2C包板协议 0-未同意、1-已同意
                protocolUrl: '',// 协议链接
                packageBoardProtocolDialogShow: -1,
                
                // 缺口明细
                userDateRangeList: [],
                userDiscrepancyTotal: '', // 缺口重量合计
                gapVisible: false,
                gapIdx: '',
                gapLoading: false,

                // 区域列表
                areaList: [],
                
                selectDate: '',
                // 板列表
                boardList: [],
                boardLoading: false,
                
                // 倒计时定时器
                countdownTimer: -1,
                countdownTime: -1,
                
                sizeRemarkIsShow: false,
                orderSizeNoteObj: null,
                sizeNoteList: [
                    {
                        pieces: '',
                        length: '',
                        width: '',
                        high: ''
                    }
                ],

                QBItineraryInfoShow: false,
                QBItineraryInfoLoading: false,
                QBItineraryInfo: {
                    endPort: '',
                    departureTime: '',// 起飞时间
                    stop: '',// 中转港（直达返回空）
                    stopTime: '',// 停留时间（直达返回空）
                    arrivalTime: '',// 到达时间（如果天数大于0，格式hh:mm +n天）
                    flightDuration: '',// 航程时间
                    // 行程详情
                    flightDetails: [],
                },
                QBItineraryInfoDataAjaxCancel: null,
                
                miscellaneousFeeListLoading: false,// 杂费清单弹窗 loading
                isShowMiscellaneousFeeListDialog: false,// 是否显示 杂费清单 弹窗
                airlinesFeeList: [],
                // 杂费清单 计费方式 列表
                billingMethodList: {
                    0: '托单重量',
                    1: '托单体积',
                    3: '固定数量',
                    4: '计费重量',
                    7: '分单数'
                },
                
                actualAfklcargoShow: false,
                actualAfklcargoDrCode: '',
                
                discrepancyTipsShow: false,

                // 预计账单时间戳
                actualBillShow: false,
                actualBillsOrderBillCode: '',
                
                
                
                // 加载中
                isShowLoading: false,
                // 费用确认数据
                confirmFeeData: {},
                
                // 实际账单
                realBill: {},
                // 判断开票状态能否切换
                isNoChoice: false,
                // 开票信息
                invoiceInfoList: [],
                // 最多可省
                maxSave: '',
                // 优惠后合计
                offPriceTotal: '',
                // 财务邮箱
                financialMail: '',
                // 开票信息模块
                submitInvoiceMod: false,
                // 电子发票禁用标志
                electronInvoiceDisSign: false,
                // 纸质发票禁用标志
                invoiceDisSign: false,
                // 不开发票禁用标志
                noInvoiceDisSign: false,
                // 开票抬头索引
                invoiceInfoIndex: 0,
                // 电子发票文字
                electronInvoiceText: '',
                // 纸质发票文字
                invoiceText: '',
                // 开票信息详情数据
                invoiceInfoItemData: {},
                // 需交保函标志
                invalidSign: '',
                // 开票信息详情标题数组
                invoiceInfoDetailTextArr: [
                    this.$t('message.invoiceName'),
                    this.$t('message.taxpayerIdNumber'),
                    this.$t('message.openBank'),
                    this.$t('message.bankAccount'),
                    this.$t('message.increaseTicketAddress'),
                    this.$t('message.shippingContactInformation'),
                    this.$t('message.shippingCall'),
                    this.$t('message.shippingContact')
                ],
                // 发票单选
                invoiceRadio: '',
                // 开票详情模块
                submitInvoiceBdMod: false,
                // 纸质发票提示
                invoiceHintsMod: false,
                // 发票提交按钮
                submitInvoiceFtMod: false,
                // 账单模块
                billGroup: false,
                // 纸质发票选择按钮
                paperInvoiceMod: false,
                // 展开更多
                expandMoreMod: true,
                // 确认费用按钮模块
                confirmMoneyButMod: true,
                // 确认费用并提交开票按钮
                confirmAndSubmit: false,
                // 保存上一次的开票状态值
                invoiceRadioOld: '',
                // 币种
                currencyType: '',
                // 合并开票 1-合并开票 0-单独开票
                invoiceMerge: '1',
                // 开票限制 0-无限制、1-本月有未开票（仅提醒）、2-上月有未开票（限制开票）
                invoiceLimit: '',
                // 预开票标志 0-非预开票、1-预开票
                preInvoicing: '',
                // 自动核销开关
                autoWriteOff: '1',
                // 开票模块修改 0-不可修改、1-可修改
                invoiceModify: '',
                
                mergeBoardDialog: false,// 合并板
                mergeBoardDialogLoading: false,
                mergeBoardTargetId: '',
                mergeBoardSourceId: '',
                
                boardWaybillDialog_visible: -1,
                boardWaybillDialog_orderBillCode: '',

                latestTimeWaybill: '',// 最晚填写运单时间（时间戳）

                
                // 锂电池
                lithiumBatteryDialog: false,
                lithiumBatteryDialogOrderObj: null,
                lithiumBatteryDialogObj: {
                    PI965: false,
                    PI966: false,
                    PI967: false,
                    PI969: false,
                    PI970: false,
                },
                
                // 注意事项
                precautionsDialog: false,
                
                // 改期
                changeDateDialog: {
                    visible: false,
                    loading: false,
                    selectDate: null,
                    dateStr: '',
                    orderBill: null,
                    boardList: [],
                    errMsg: '',
                    
                    pickerOptions: {
                        disabledDate(time) {
                            return time.getTime() <= Date.now();
                        }
                    }
                },
                reReadCalendarAbort: null
            };
        },
        computed: {
            actualBillUrl() {
                return this.baseUrl + '/personalCenter/PersonalCenterMain/operationCenter/cargoQuery/exportBusiness/CostConfirm?orderBillCode=';
            },
            // 判断登录Ajax是否完成
            loginAjaxComplete() {
                return this.$store.state.Login.loginAjaxComplete;
            },
            // 登录状态
            loginType() {
                return this.$store.state.Login.loginData.loginType;
            },
            portList() {
                return this.useAreaList.reduce((previousValue, currentValue) => {
                    return previousValue = previousValue.concat(currentValue.portList);
                }, []);
            },
            mergeBoardList() {
                let targetBoardList = this.boardList.filter(board => board.boardId === this.mergeBoardTargetId);
                if (targetBoardList.length > 0) {
                    let targetBoard = targetBoardList[0];

                    let toMergeBoardList = this.boardList.filter(board => board.boardId !== targetBoard.boardId && board.type === targetBoard.type);
                    return toMergeBoardList.map(board => {
                        return {
                            label: board.boardName,
                            value: board.boardId
                        };
                    });
                }
                return [];
            },
            useAreaList() {
                return this.areaList;
            },
            flightCode() {
                if (this.selectDate) {
                    let selectDate = this.$moment(this.selectDate);
                    if (this.dateList.some(date => Number(date.date) === selectDate.toDate().getTime())) {
                        return this.dateList.filter(date => Number(date.date) === selectDate.toDate().getTime())[0].flightCode;
                    } else {
                        return '';
                    }

                } else {
                    return '';
                }
            },
            
            // 航程网站链接
            actualAfklcargoUrl() {
                // 003开头运单
                if (this.actualAfklcargoDrCode.startsWith('003')) {
                    return 'https://pathfinder.digitalfactory.aero/';
                }
                return 'https://www.afklcargo.com/mycargo/shipment/detail/';
            },
            isOverBoardDate5Day() {
                if (this.selectDate) {
                    return new Date().getTime() > this.$moment(this.selectDate).add(5, 'day').toDate().getTime();
                }
                return false;
            }
        },
        watch: {
            loginAjaxComplete() {
                if (this.loginAjaxComplete) {
                    if (this.loginType) {
                        this.init();
                    } else {
                        this.$showLogin();
                    }
                }
            },
            elTabIdx(newVal, oldVal) {
                if (!newVal && oldVal) {
                    newVal = oldVal;
                }
            },
            dateList() {
                if (this.dateList.length > 0) {
                    this.calendarDateRange = [];
                    this.calendarDateRange.push(this.$moment(Number(this.dateList[0].date)).format('YYYY-MM-DD'));
                    this.calendarDateRange.push(this.$moment(Number(this.dateList[this.dateList.length - 1].date)).format('YYYY-MM-DD'));
                } else {
                    this.calendarDateRange = [];
                }
            },
            selectDate() {
                this.getDateBoardAllocationData();
            },
            boardList: {
                handler(newVal) {
                    if (this.boardList.length > 0) {
                        if (this.elTabIdx) {
                            if (this.boardList.filter(board => board.boardId === this.elTabIdx).length === 0) {
                                this.elTabIdx = this.boardList[0].boardId;
                            }
                        } else {
                            this.elTabIdx = this.boardList[0].boardId;
                        }
                    }
                    for (let i = 0; i < newVal.length; i++) {
                        let board = this.boardList[i];
                        // region 计算单价
                        for (let j = 0; j < board.orderBillList.length; j++) {
                            let order = board.orderBillList[j];

                            if (order.endPort !== '' && order.endPort.length === 3) {
                                for (let a = 0; a < this.useAreaList.length; a++) {
                                    let area = this.useAreaList[a];
                                    for (let p = 0; p < area.portList.length; p++) {
                                        let port = area.portList[p];
                                        if (port.port === order.endPort) {
                                            order.costPrice = (Number(board.costPrice) + Number(area.costPriceDiff)).toFixed(2);
                                        }
                                    }
                                }
                            } else {
                                order.costPrice = '';
                            }
                        }
                        // endregion
                        
             
                        
                        // region 计算合计
                        let piecesTotal = new this.$Decimal(0);
                        let weightTotal = new this.$Decimal(0);
                        let volumeTotal = new this.$Decimal(0);
                        let feeWeightTotal = new this.$Decimal(0);
                        for (let j = 0; j < board.orderBillList.length; j++) {
                            let order = board.orderBillList[j];
                            if (order.pieces) {
                                piecesTotal = piecesTotal.add(new this.$Decimal(order.pieces));
                            }
                            if (order.weight) {
                                weightTotal = weightTotal.add(new this.$Decimal(order.weight));
                            }
                            if (order.volume) {
                                volumeTotal = volumeTotal.add(new this.$Decimal(order.volume));
                            }
                            if (order.feeWeight) {
                                feeWeightTotal = feeWeightTotal.add(order.feeWeight);
                            }
                        }
                        board.piecesTotal = piecesTotal.toFixed(0);
                        board.weightTotal = weightTotal.toFixed(0);
                        board.volumeTotal = volumeTotal.toFixed(3);
                        board.feeWeightTotal = feeWeightTotal.toFixed(0);
                        // endregion
                    }
                },
                deep: true
            },
            QBItineraryInfoShow(newVal) {
                if (!newVal && this.QBItineraryInfoDataAjaxCancel) {
                    this.$ajaxCancel(this.QBItineraryInfoDataAjaxCancel);
                }
            },
            actualAfklcargoShow(newVal) {
                if (!newVal) {
                    this.actualAfklcargoDrCode = '';
                }
            },
            // 监听开票状态值得变化
            invoiceRadio(newV, oldV) {
                this.invoiceRadioOld = oldV;
            },
            mergeBoardList() {
                if (this.mergeBoardList.length > 0) {
                    this.mergeBoardSourceId = this.mergeBoardList[0].value;
                } else {
                    this.mergeBoardSourceId = '';
                }
            },
        },
        mounted() {
            this.init();
            
        },
        methods: {
            // 倒计时渲染
            countdownRenderer(countdown) {
                const time = countdown / 1000;
                const hour = Math.floor(time / 3600);
                const minute = Math.floor(time % 3600 / 60);
                const second = Math.floor(time % 3600 % 60);
                return {
                    h: this.$countdownFormat(hour),
                    m: this.$countdownFormat(minute),
                    s: this.$countdownFormat(second)
                };
            },
            // 倒计时定时器启动
            countdownTimerFn(board) {
                board.ebookingLastTimer = setInterval(() => {
                    board.ebookingLastTime = board.ebookingLastTime - 1000;
                    // 倒计时结束
                    if (board.ebookingLastTime <= 0) {
                        clearInterval(board.ebookingLastTimer);// 清除定时器
                    }
                }, 1000);
            },
            init() {
                this.pageLoading = true;
                if (!this.loginAjaxComplete || !this.loginType) {
                    return;
                }                
                let promise1 = this.getUserBoardAllocationMainData();
                let promise2 = this.initDateList();
                Promise.all([promise1, promise2]).then(() => {
                    this.pageLoading = false;
                });
            },
            addOrder(boardIdx) {
                let board = this.boardList[boardIdx];
                // if (board.orderBillList.some(orderBill => orderBill.bupType === '1')) {
                //     this.$Alert({
                //         msg: '该板选择了BUP，只能有一票订单'
                //     });
                //     return;
                // }
                if (board.orderBillList.some(orderBill => orderBill.bupTypeClone === '1' && orderBill.bupType !== '1')) {
                    this.$Alert({
                        msg: '该板去除BUP选项后未保存，请保存后再试'
                    });
                    return;
                }
                
                
                this.$ajax({
                    url: '/AllocationBoardHandler/AllocationBoardHandler.ashx',
                    data: {
                        act: 'getPackageBoardDrcodeData',// 获取包板运单号的数据
                        productNo: this.productNo,// 产品编号
                        boardId: board.boardId,// 板ID
                    },
                    beforeSend: () => {
                        this.orderLoading = true;
                    },
                    success: (res) => {
                        this.boardList[boardIdx].orderBillList.push({
                            orderBillCode: res.success.orderBillCode,// 托单号
                            drCode: res.success.airCarrierCode + res.success.drCode,// 运单号
                            endPort: '',// 目的港
                            // 订舱数据
                            pieces: '',// 件数
                            weight: '',// 重量
                            volume: '',// 体积
                            packageWay: '0',// 0-散货、1-托盘
                            batteryInfo: [],// 锂电池信息
                            bupType: '0',// 是否BUP 0-N、1-Y
                            // 订舱尺寸备注
                            sizeNote: [],
                            costPrice: '',// 成本单价
                            feeWeight: '',// 计费重量 
                            orderStatus: '',// 订单状态 0-已保存、1-审核中、2-已完成
                            waybillType: '0',// 是否填过运单信息 0-N、1-Y
                        });
                    },
                    complete: () => {
                        this.orderLoading = false;
                    }
                });
                
                
            },
            initDateList() {
                return new Promise(resolve => {
                    this.$ajax({
                        url: '/AllocationBoardHandler/AllocationBoardHandler.ashx',
                        data: {
                            act: 'getUserBoardCalendarData',// 获取用户包板日历的数据
                            startDate: '', // 开始日期（可传空）
                            endDate: '', // 结束日期（可传空）
                        },
                        beforeSend: () => {
                            this.pageLoading = true;
                        },
                        success: (res) => {
                            this.dateList = res.success.dateList;
                            
                            this.$nextTick(() => {
                                let currIdx = this.dateList.findIndex(date => this.$moment(Number(date.date)).format('YYYY-MM-DD') === this.$moment(new Date()).format('YYYY-MM-DD'));
                                let swiperOption = this.mySwiperOption;
                                if (currIdx >= 0) {
                                    swiperOption = {
                                        ...swiperOption,
                                        initialSlide: currIdx
                                    };
                                }
                                this.mySwiper = new this.$swiper('.swiper-container', swiperOption);
                            });
                            resolve();
                        },
                        complete: () => {
                            this.pageLoading = false;
                        }
                    });
                });


            },
            toPrev() {
                this.mySwiper.slidePrev();
            },
            toNext() {
                this.mySwiper.slideNext();
            },
            getDateInfo(date) {
                let dateStr = this.$moment(date).startOf('d').toDate().getTime().toString();
                if (this.dateList.some(date1 => date1.date === dateStr)) {
                    
                    return this.dateList.filter(date1 => date1.date === dateStr)[0];
                }
                return null;
            },
            switchDate(type) {
                let startDate = '';
                let endDate = '';
                if (type === 'prev') {
                    let dateStr = this.calendarDateRange[0];
                    startDate = this.$moment(dateStr).add(-28, 'day').format('YYYY-MM-DD');
                    endDate = this.$moment(dateStr).add(-1, 'day').format('YYYY-MM-DD');

                } else if (type === 'next') {
                    let dateStr = this.calendarDateRange[1];
                    startDate = this.$moment(dateStr).add(1, 'day').format('YYYY-MM-DD');
                    endDate = this.$moment(dateStr).add(28, 'day').format('YYYY-MM-DD');
                }
                this.$ajax({
                    url: '/AllocationBoardHandler/AllocationBoardHandler.ashx',
                    data: {
                        act: 'getUserBoardCalendarData',// 获取用户包板日历的数据
                        startDate: startDate, // 开始日期（可传空）
                        endDate: endDate, // 结束日期（可传空）
                    },
                    beforeSend: () => {
                        this.calendarLoading = true;
                    },
                    success: (res) => {
                        this.dateList = res.success.dateList;
                        
                        this.$nextTick(() => {
                            let currIdx = this.dateList.findIndex(date => this.$moment(Number(date.date)).format('YYYY-MM-DD') === this.$moment(new Date()).format('YYYY-MM-DD'));
                            if (currIdx >= 0) {
                                this.mySwiper.slideTo(currIdx,0);
                            }
                        });
                    },
                    complete: () => {
                        this.calendarLoading = false;
                    }
                });
            },

            // 获取用户配板主页的数据
            getUserBoardAllocationMainData() {
                return new Promise(resolve => {
                    this.$ajax({
                        url: '/AllocationBoardHandler/AllocationBoardHandler.ashx',
                        data: {
                            act: 'getUserBoardAllocationMainData',// 获取用户配板主页的数据
                        },
                        success: (res) => {
                            this.airline = res.success.airline;
                            this.airlineName = res.success.airlineName;
                            this.productNo = res.success.productNo;
                            this.startPort = res.success.startPort;
                            this.latestTimeTips = res.success.latestTimeTips;
                            this.discrepancyTotal = res.success.discrepancyTotal;
                            this.customerService = res.success.customerService;
                            this.operationsCompanyHistory = res.success.operationsCompanyHistory;
                            this.packageBoardProtocol = res.success.packageBoardProtocol;
                            this.protocolUrl = res.success.protocolUrl;
                            if (this.packageBoardProtocol !== '1') {
                                this.packageBoardProtocolDialogShow = Math.random();
                            }
                            this.getTransitAreaCostListData();
                            this.getPackageBoardMiscellaneousFeeListData();
                            resolve();
                        }
                    });
                });
            },
            
            // 获取用户板缺口明细的数据
            getUserDiscrepancyDetailsData(type) {
                this.gapIdx = type;
                this.$ajax({
                    url: '/AllocationBoardHandler/AllocationBoardHandler.ashx',
                    data: {
                        act: 'getUserDiscrepancyDetailsData',// 获取用户板缺口明细的数据
                        type: type,// 类型 0-HARD板、1-SOFT板、2-FREE板
                    },
                    beforeSend: () => {
                        this.gapVisible = true;
                        this.gapLoading = true;
                        this.userDateRangeList = [];
                        this.userDiscrepancyTotal = '';
                    },
                    success: (res) => {
                        this.userDateRangeList = res.success.dateRangeList;
                        this.userDiscrepancyTotal = res.success.discrepancyTotal;
                    },
                    complete: () => {
                        this.gapLoading = false;
                    }
                });
            },
            
            // 获取转运区成本列表的数据
            getTransitAreaCostListData() {
                this.$ajax({
                    url: '/AllocationBoardHandler/AllocationBoardHandler.ashx',
                    data: {
                        act: 'getTransitAreaCostListData',// 获取转运区成本列表的数据
                        productNo: this.productNo,// 产品编号
                    },
                    beforeSend: () => {
                        this.areaList = [];  
                    },
                    success: (res) => {
                        this.areaList = res.success.areaList;
                    }
                });
            },
            
            // 获取指定日期配板的数据
            getDateBoardAllocationData() {
                this.$ajax({
                    url: '/AllocationBoardHandler/AllocationBoardHandler.ashx',
                    data: {
                        act: 'getDateBoardAllocationData',// 获取指定日期配板的数据
                        date: this.selectDate, // 日期
                    },
                    beforeSend: () => {
                        this.boardList = [];  
                        this.boardLoading = true;
                    },
                    success: (res) => {

                        res.success.boardList.forEach(board => {
                            board.orderBillList = board.orderBillList.map(order => {
                                return {
                                    checkBoxSelected: false,
                                    ...order,
                                    bupTypeClone: order.bupType
                                };
                            });
                        });
                        
                        this.boardList = res.success.boardList;
                        this.boardList.forEach(board => {
                            this.countdownTimerFn(board);
                        });
                    },
                    complete: () => {
                        this.boardLoading = false;
                    }
                });
            },
            
            onPackageWaySwitch(item) {
                if (item.packageWay === '1' && item.sizeNote.length === 0) {
                    this.openBookingSizeNoteDialog(item);
                }
            },

            // 提交删除板上订单的数据
            postDeleteBoardOrderData(boardId, orderBillCode) {

                this.$ajax({
                    url: '/AllocationBoardHandler/AllocationBoardHandler.ashx',
                    data: {
                        act: 'postDeleteBoardOrderData',// 提交删除板上订单的数据
                        boardId: boardId,
                        orderBillCode: orderBillCode,// 托单号
                    },
                    beforeSend: () => {
                        this.boardLoading = true;
                    },
                    errCallback: () => {
                        this.boardLoading = false;
                    },
                    success: () => {
                        let boardIdx = this.boardList.findIndex(board => board.boardId === boardId);
                        let orderIdx = this.boardList[boardIdx].orderBillList.findIndex(order => order.orderBillCode === orderBillCode);
                        this.boardList[boardIdx].orderBillList.splice(orderIdx,1);
                        this.boardLoading = false;
                        
                    }
                });
                
                
            },
            
            // 提交保存配板的数据
            postSaveBoardAllocationData(board) {
                let orderBillList = board.orderBillList.filter(orderBill => !['1','2'].includes(orderBill.orderStatus));
                // let hasEndPortEmptyParam = orderBillList.some(order => order.endPort === '');
                // if (hasEndPortEmptyParam) {
                //     this.$Alert({
                //         msg: '目的港不能为空'
                //     });
                //     return;
                // }
                // let hasPiecesEmptyParam = orderBillList.some(order => order.pieces === '');
                // if (hasPiecesEmptyParam) {
                //     this.$Alert({
                //         msg: '件数不能为空'
                //     });
                //     return;
                // }
                // let hasWeightEmptyParam = orderBillList.some(order => order.weight === '');
                // if (hasWeightEmptyParam) {
                //     this.$Alert({
                //         msg: '重量不能为空'
                //     });
                //     return;
                // }
                //
                // let hasVolumeEmptyParam = orderBillList.some(order => order.volume === '');
                // if (hasVolumeEmptyParam) {
                //     this.$Alert({
                //         msg: '体积不能为空'
                //     });
                //     return;
                // }
                
                if (board.weightTotal && Number(board.weightTotal) > Number(board.maximumWeight)) {
                    this.$Alert({
                        msg: `该板合计重量超过最大重量${board.maximumWeight}公斤，不能保存，请修改后重试`
                    });
                    return;
                }
                
                for (let i = 0; i < orderBillList.length; i++) {
                    let order = orderBillList[i];
                    if (order.weight && Number(order.weight) < 100) {
                        this.$Alert({
                            msg: '运单号: ' + order.drCode + ' 重量需大于等于100公斤'
                        });
                        return;
                    } 
                }
                
                // region 判断港口关闭
                for (let i = 0; i < orderBillList.length; i++) {
                    let order = orderBillList[i];
                    if (order.endPort) {
                        if (this.portList.some(port => port.port === order.endPort)) {
                            let port_obj = this.portList.filter(port => port.port === order.endPort)[0];
                            if (port_obj.closeFlag.includes(this.$moment(this.selectDate).format('E'))) {
                                this.$Alert({
                                    msg: '港口: ' + port_obj.port + ' 已关闭，不能选择'
                                });
                                return;
                            }
                        }
                        else {
                            this.$Alert({
                                msg: `运单号${order.drCode}，所填的目的港不支持当前产品`
                            });
                            return;
                        }
                    }
                }
                // endregion

                for (let i = 0; i < orderBillList.length; i++) {
                    let order = orderBillList[i];
                    if (order.packageWay === '1' && order.sizeNote.length === 0) {
                        this.$Alert({
                            msg: '运单' + order.drCode + ' 托盘需填写尺寸'
                        });
                        return;
                    }
                }


                // if (orderBillList.filter(orderBill => orderBill.bupType === '1').length > 0 && orderBillList.length > 1) {
                //     this.$Alert({
                //         msg: '该板选择了BUP，只能有一票订单'
                //     });
                //     return;
                // }

                if (!board.operationsCompany) {
                    this.$Alert({
                        msg: '打板公司不能为空'
                    });
                    return;
                }

                // 板合计重量超过预警重量
                if (Number(board.weightTotal) > 0 && Number(board.warningWeight) > 0 && Number(board.weightTotal) > Number(board.warningWeight)) {
                    this.$Confirm({
                        msg: `该板重量超过${board.warningWeight}，请联系客服提前报备，以免飞不掉`,
                        showCancelButton: false,
                        confirmButtonText: '知道了',
                        showClose: false,
                        callback: () => {
                            this.$ajax({
                                url: '/AllocationBoardHandler/AllocationBoardHandler.ashx',
                                data: {
                                    act: 'postSaveBoardAllocationData',// 提交保存配板的数据
                                    boardId: board.boardId, // 板ID
                                    operationsCompany: board.operationsCompany,// 打板公司
                                    // 订单列表
                                    orderBillList: JSON.stringify(orderBillList),
                                },
                                beforeSend: () => {
                                    this.boardLoading = true;
                                },
                                errCallback: () => {
                                    this.boardLoading = false;
                                },
                                success: () => {
                                    this.$Alert({
                                        msg: '保存成功'
                                    });
                                    this.getDateBoardAllocationData();
                                },
                            });
                        }
                    });
                    return;
                }
                
                
                this.$ajax({
                    url: '/AllocationBoardHandler/AllocationBoardHandler.ashx',
                    data: {
                        act: 'postSaveBoardAllocationData',// 提交保存配板的数据
                        boardId: board.boardId, // 板ID
                        operationsCompany: board.operationsCompany,// 打板公司
                        // 订单列表
                        orderBillList: JSON.stringify(orderBillList),
                    },
                    beforeSend: () => {
                        this.boardLoading = true;
                    },
                    errCallback: () => {
                        this.boardLoading = false;
                    },
                    success: () => {
                        this.$Alert({
                            msg: '保存成功'
                        });
                        this.getDateBoardAllocationData();
                    },
                });
            },
            // 一天里有板
            hasBoardInOneDate(oneDate) {
                return oneDate && (oneDate.hardBoardType === '1' || oneDate.softBoardType === '1' || oneDate.freeBoardType === '1');
            },

            addSizeNote() {
                if (!this.orderSizeNoteObj || !['1','2'].includes(this.orderSizeNoteObj.orderStatus)) {
                    this.sizeNoteList.push({
                        pieces: '',
                        length: '',
                        width: '',
                        high: ''
                    });
                }
            },
            deleteSizeNote(index) {
                if (!this.orderSizeNoteObj || !['1','2'].includes(this.orderSizeNoteObj.orderStatus)) {
                    this.sizeNoteList.splice(index, 1);
                }
            },
            // 获取QB行程信息的数据
            getQBItineraryInfoData(destination) {
                if (!destination) {
                    return;
                }
                if (destination.length !== 3) {
                    return;
                }
                this.QBItineraryInfoShow = true;
                this.$ajax({
                    name: 'QBItineraryInfoDataAjaxCancel',
                    url: '/SmartProductsHandler/ProductSearch/ProductResultHandler.ashx',
                    data: {
                        act: 'getQBItineraryInfoData',// 获取QB行程信息的数据
                        startPort: this.startPort,// 起始港
                        destination: destination,// 目的港
                        airline: this.airline,// 航空公司简称
                        productDate: this.selectDate,// 开航日期
                    },
                    beforeSend: () => {
                        this.QBItineraryInfoLoading = true;
                        this.QBItineraryInfo = {
                            endPort: destination,
                            departureTime: '',// 起飞时间
                            stop: '',// 中转港（直达返回空）
                            stopTime: '',// 停留时间（直达返回空）
                            arrivalTime: '',// 到达时间（如果天数大于0，格式hh:mm +n天）
                            flightDuration: '',// 航程时间
                            // 行程详情
                            flightDetails: [],
                        };
                    },
                    errCallback: () => {
                        this.QBItineraryInfoShow = false;
                        this.QBItineraryInfoLoading = false;
                    },
                    success: (res) => {
                        this.QBItineraryInfoLoading = false;
                        this.QBItineraryInfo = res.success;
                    },
                    complete: () => {
                        
                    }
                });
            },
            
            // 提交退板的数据
            postReturnBoardData(boardId) {
                this.$ajax({
                    url: '/AllocationBoardHandler/AllocationBoardHandler.ashx',
                    data: {
                        act: 'postReturnBoardData',// 提交退板的数据
                        boardId: boardId,// 板ID
                    },
                    beforeSend: () => {
                        this.boardLoading = true;
                    },
                    errCallback: () => {
                        this.boardLoading = false;
                    },
                    success: () => {
                        this.getDateBoardAllocationData();
                    }
                });
            },
            sizeNoteEnter() {
                if (this.orderSizeNoteObj && ['1', '2'].includes(this.orderSizeNoteObj.orderStatus)) {
                    this.sizeRemarkIsShow = false;
                    return;
                }
                if (this.sizeNoteList.length === 1 && this.sizeNoteList.some(sizeNote => sizeNote.pieces === '' && sizeNote.length === '' && sizeNote.width === '' && sizeNote.high === '')) {
                    this.sizeRemarkIsShow = false;
                    return;
                }
                
                
                if (this.sizeNoteList.some(sizeNote => sizeNote.pieces === '' || sizeNote.length === '' || sizeNote.width === '' || sizeNote.high === '')) {
                    this.$Alert({
                        msg: '请将尺寸数据填写完整'
                    });
                    return;
                }
                this.recalculateVolume1();
                this.orderSizeNoteObj.sizeNote = this.sizeNoteList;
                this.sizeRemarkIsShow = false;
            },
            // 提交包板取消EBOOKING的数据
            postPackageBoardCancelEbookingData(boardId,orderBillCode) {
                this.$ajax({
                    url: '/AllocationBoardHandler/AllocationBoardHandler.ashx',
                    data: {
                        act: 'postPackageBoardCancelEbookingData',// 提交包板取消EBOOKING的数据
                        boardId: boardId,// 板ID
                        orderBillCode: orderBillCode,// 托单号
                    },
                    beforeSend: () => {
                        this.boardLoading = true;
                    },
                    errCallback: () => {
                        this.boardLoading = false;
                    },
                    success: () => {
                        this.$Alert({
                            msg: '取消成功'
                        });

                        this.getDateBoardAllocationData();

                    }
                });
            },

            postPackageBoardSendEbookingData(board) {
                let lockBoard = '0';
                let selOrderList = board.orderBillList.filter(orderBill => !['1', '2'].includes(orderBill.orderStatus) && orderBill.checkBoxSelected);
                let totalEbookingNum = board.orderBillList.filter(orderBill => ['1', '2'].includes(orderBill.orderStatus)).length + selOrderList.length;
                
                if (board.lockBoard !== '1' && totalEbookingNum === board.orderBillList.length) {
                    this.$Confirm({
                        msg: '是否锁板?',
                        cancelButtonText: '否',
                        confirmButtonText: '是',
                        callback: () => {
                            lockBoard = '1';
                            let orderBillCodeList = selOrderList.map(order => order.orderBillCode);
                            this.$ajax({
                                url: '/AllocationBoardHandler/AllocationBoardHandler.ashx',
                                data: {
                                    act: 'postPackageBoardSendEbookingData',// 提交包板发送E-BOOKING的数据
                                    boardId: board.boardId,// 板ID
                                    orderBillCodeList: JSON.stringify(orderBillCodeList),// 托单号列表
                                    lockBoard: lockBoard,// 是否锁板 0-N、1-Y
                                },
                                beforeSend: () => {
                                    this.boardLoading = true;
                                },
                                errCallback: () => {
                                    this.boardLoading = false;
                                },
                                success: () => {
                                    this.$Alert({
                                        msg: '发送成功'
                                    });
                                    this.getDateBoardAllocationData();
                                }
                            });
                        },
                        cancel: () => {
                            let orderBillCodeList = selOrderList.map(order => order.orderBillCode);
                            this.$ajax({
                                url: '/AllocationBoardHandler/AllocationBoardHandler.ashx',
                                data: {
                                    act: 'postPackageBoardSendEbookingData',// 提交包板发送E-BOOKING的数据
                                    boardId: board.boardId,// 板ID
                                    orderBillCodeList: JSON.stringify(orderBillCodeList),// 托单号列表
                                    lockBoard: lockBoard,// 是否锁板 0-N、1-Y
                                },
                                beforeSend: () => {
                                    this.boardLoading = true;
                                },
                                errCallback: () => {
                                    this.boardLoading = false;
                                },
                                success: () => {
                                    this.$Alert({
                                        msg: '发送成功'
                                    });
                                    this.getDateBoardAllocationData();
                                }
                            });
                        }
                    });
                } else {
                    let orderBillCodeList = selOrderList.map(order => order.orderBillCode);
                    this.$ajax({
                        url: '/AllocationBoardHandler/AllocationBoardHandler.ashx',
                        data: {
                            act: 'postPackageBoardSendEbookingData',// 提交包板发送E-BOOKING的数据
                            boardId: board.boardId,// 板ID
                            orderBillCodeList: JSON.stringify(orderBillCodeList),// 托单号列表
                            lockBoard: lockBoard,// 是否锁板 0-N、1-Y
                        },
                        beforeSend: () => {
                            this.boardLoading = true;
                        },
                        errCallback: () => {
                            this.boardLoading = false;
                        },
                        success: () => {
                            this.$Alert({
                                msg: '发送成功'
                            });
                            this.getDateBoardAllocationData();
                        }
                    });
                }
                

            },

            // 获取包板杂费清单的数据
            getPackageBoardMiscellaneousFeeListData() {
                this.$ajax({
                    url: '/AllocationBoardHandler/AllocationBoardHandler.ashx',
                    data: {
                        act: 'getPackageBoardMiscellaneousFeeListData',// 获取包板杂费清单的数据
                        productNo: this.productNo,// 产品编号
                    },
                    beforeSend: () => {
                        this.miscellaneousFeeListLoading = true;  
                    },
                    success: (res) => {
                        this.airlinesFeeList = res.success.airlinesFeeList;
                    },
                    complete: () => {
                        this.miscellaneousFeeListLoading = false;
                    }
                });
            },
            // 板不能修改
            boardDisableEdit(board) {
                if (board.returnBoard !== '') {
                    return true;
                } else if (board.ebookingTimeType === '2') {
                    return true;
                }
                return false;
            },
            createFilter(queryString) {
                return (port) => {
                    return (port.value.toUpperCase().indexOf(queryString.toUpperCase()) === 0);
                };
            },
            querySearchEndPort(queryString, cb) {
                let endPortOptions = this.portList.filter(port => !port.closeFlag.includes(this.$moment(this.selectDate).format('E'))).map(port => {
                    return {
                        value: port.port
                    };
                });
                let results = queryString ? endPortOptions.filter(this.createFilter(queryString)) : endPortOptions;
                // 调用 callback 返回建议列表的数据
                cb(results);
            },
            querySearchOperationCompany(queryString, cb) {
                let companyOptions = this.operationsCompanyHistory.map(company => {
                    return {
                        value: company
                    };
                });
                let results = queryString ? companyOptions.filter(this.createFilter(queryString)) : companyOptions;
                // 调用 callback 返回建议列表的数据
                cb(results);
            },

            querySearchPackage(queryString, cb) {
                let restaurants = this.packageMethodList;
                let results = queryString ? restaurants.filter(this.createFilterPackage(queryString)) : restaurants;
                // 调用 callback 返回建议列表的数据
                cb(results);
            },
            createFilterPackage(queryString) {
                return (restaurant) => {
                    return (restaurant.value.toLowerCase().indexOf(queryString.toLowerCase()) === 0);
                };
            },

            // 查看账单
            viewBills(orderBillCode) {
                this.actualBillShow = true;
                this.actualBillsOrderBillCode = orderBillCode;
                this.getConfirmFeeDataAjax();
            },

            // 费用确认 初始化数据ajax
            getConfirmFeeDataAjax() {
                return new Promise((resolve) => {
                    this.$ajax({
                        url: '/personalCenterHandler/operationCenter/cargoQuery/exportBusiness/CostConfirmHandler.ashx',
                        data: {
                            act: 'getConfirmFeeData',// 获取 费用确认数据
                            orderBillCode: this.actualBillsOrderBillCode,// 托单号
                        },
                        beforeSend: () => {
                            // 页面回归最顶部
                            window.scrollTo(0, 0);
                            this.realBill = {};
                            this.isNoChoice = false;
                            this.invoiceInfoList = [];
                            this.maxSave = '';
                            this.offPriceTotal = '';
                            this.financialMail = '';
                            this.submitInvoiceMod = false;
                            this.electronInvoiceDisSign = false;
                            this.invoiceDisSign = false;
                            this.noInvoiceDisSign = false;
                            this.invoiceInfoIndex = 0;
                            this.invoiceInfoItemData = {};
                            this.invalidSign = '';
                            this.invoiceRadio = '';
                            this.submitInvoiceBdMod = false;
                            this.invoiceHintsMod = false;
                            this.submitInvoiceFtMod = false;
                            this.billGroup = false;
                            this.paperInvoiceMod = false;
                            this.expandMoreMod = true;
                            this.confirmMoneyButMod = true;
                            this.confirmAndSubmit = false;
                            this.invoiceRadioOld = '';
                            this.currencyType = '';
                            this.invoiceMerge = '1';
                            this.invoiceLimit = '';
                            this.preInvoicing = '';
                            this.autoWriteOff = '1';
                            this.invoiceModify = '';
                            // 加载中添加
                            this.isShowLoading = true;
                        },
                        success: (res) => {
                            
                            // 费用确认数据
                            this.confirmFeeData = res.success;
                            // 实际账单
                            this.realBill = this.confirmFeeData.realBill;
                            // 接口返回值判断绑定
                            if (this.confirmFeeData.invoiceMerge === '0') {
                                this.invoiceMerge = '0';
                            } else {
                                this.invoiceMerge = '1';
                            }
                            // 币种
                            this.currencyType = this.confirmFeeData.currencyType;
                            // 开票限制
                            this.invoiceLimit = this.confirmFeeData.invoiceLimit;
                            // 预开票标志
                            this.preInvoicing = this.confirmFeeData.preInvoicing;
                            // 实际账单
                            this.realBill = this.confirmFeeData.realBill;
                            // 开票信息
                            this.invoiceInfoList = this.confirmFeeData.invoiceInfoList;
                            // 判断开票状态能否切换
                            if (this.confirmFeeData.invoiceMerge !== '') {
                                this.isNoChoice = true;
                            }
                            // 开票模块修改 0-不可修改、1-可修改
                            this.invoiceModify = res.success.invoiceModify;
                            
                            this.costConfirmDetailRender();
                            this.isShowLoading = false;
                            // 放行
                            resolve();
                        }
                    });
                });
            },
            // 当参数为空时，返回"-"
            returnEmpty(data) {
                if (data === '') {
                    data = ' - ';
                }
                return data;
            },
            // 查看方案
            viewPlanClick() {
                // 方案弹窗
                this.planTableDialog = true;
            },
            // 查看原账单
            viewOriginalBillClick() {
                // 原预计账单弹窗
                this.originalEstimatedBillDialog = true;
            },

            // 费用确认 页面详情渲染
            costConfirmDetailRender() {
                // 优惠后合计
                this.offPriceTotal = this.realBill.total;
                // 财务邮箱
                this.financialMail = this.confirmFeeData.financialMailbox;
                // 是否有开票信息
                if (this.invoiceInfoList.length === 0) {
                    // 电子发票禁用标志
                    this.electronInvoiceDisSign = true;
                    // 纸质发票禁用标志
                    this.invoiceDisSign = true;
                    // 电子发票文字
                    this.electronInvoiceText = this.$t('message.noElectronInvoiceInfo');
                    // 纸质发票文字
                    this.invoiceText = this.$t('message.noInvoiceInfo');
                } else {
                    // 开票抬头模拟选择
                    this.invoiceTitSelect(this.invoiceInfoIndex);
                    // 电子发票禁用标志
                    this.electronInvoiceDisSign = false;
                    // 纸质发票禁用标志
                    this.invoiceDisSign = false;
                    // 电子发票文字
                    this.electronInvoiceText = this.$t('message.electronInvoice');
                    // 纸质发票文字
                    this.invoiceText = this.$t('message.invoice');
                }
                
                // 未确认费用（确认费用开票2合1）
                if (this.confirmFeeData.confirmFee === '0') {

                    // 确认费用按钮隐藏
                    this.confirmMoneyButMod = false;
                    // 开票模块
                    this.submitInvoiceMod = true;
                    // 显示2合1提交按钮 同时隐藏普通开票按钮
                    this.confirmAndSubmit = true;

                } else {// 分开确认费用 && 开票

                    // 判断是否已经确认费用
                    if (this.confirmFeeData.confirmFee === '1') {// 已确认费用
                        if (this.confirmFeeData.invoiceType === '0') {// 未开票
                            // 开启开票模块
                            this.submitInvoiceMod = true;
                        }
                    }

                }

                // 账单模块
                this.billGroup = true;

                // 判断是海外用户就默认选中DEBIT NOTE
                if (this.$overseasType) {
                    // 发票单选
                    this.invoiceRadio = '0';
                    // 不开发票禁用标志
                    this.noInvoiceDisSign = false;
                } else {
                    // 默认开票方式
                    switch (this.confirmFeeData.defaultInvoiceType) {
                        case '0':// 0-无默认值
                            // 发票单选
                            this.invoiceRadio = '2';
                            break;
                        case '1':// 1-电子发票
                            // 发票单选
                            this.invoiceRadio = '2';
                            // 电子发票禁用标志
                            this.electronInvoiceDisSign = false;
                            // 纸质发票禁用标志
                            this.invoiceDisSign = true;
                            // 不开发票禁用标志
                            // this.noInvoiceDisSign = true;
                            // 纸质发票按钮模块显示
                            this.paperInvoiceMod = true;
                            // 展开更多隐藏
                            this.expandMoreMod = false;
                            break;
                        case '2':// 2-DEBIT NOTE
                            // 发票单选
                            this.invoiceRadio = '0';
                            // 电子发票禁用标志
                            // this.electronInvoiceDisSign = true;
                            // 纸质发票禁用标志
                            this.invoiceDisSign = true;
                            // 不开发票禁用标志
                            this.noInvoiceDisSign = false;
                            // 纸质发票按钮模块显示
                            this.paperInvoiceMod = true;
                            // 展开更多隐藏
                            this.expandMoreMod = false;
                            break;
                        case '3':// 3-纸质发票

                            // 发票单选
                            this.invoiceRadio = '2';
                            // 电子发票禁用标志
                            this.electronInvoiceDisSign = false;
                            // 纸质发票禁用标志
                            this.invoiceDisSign = true;
                            // 不开发票禁用标志
                            // this.noInvoiceDisSign = true;
                            // 纸质发票按钮模块显示
                            this.paperInvoiceMod = true;
                            // 展开更多隐藏
                            this.expandMoreMod = false;
                            break;
                    }
                }
                
                // 发票类型选择
                this.invoiceTypeSelChange();
            },
            // 发票类型选择是否禁用
            invoiceTypeBtnIsDisabled(val) {
                // disbaled 数组
                const disabledTypeList = {
                    0: this.noInvoiceDisSign,
                    1: this.invoiceDisSign,
                    2: this.electronInvoiceDisSign
                };
                return disabledTypeList[val];
            },
            // 开票抬头选择
            invoiceTitSelect(index) {
                // 开票信息详情数据
                this.invoiceInfoItemData = this.invoiceInfoList[index];
                // 是否需交保函标志
                this.invalidSign = this.invoiceInfoItemData.invalid;
            },
            // 发票切换
            invoiceTypeRadioChange(val) {
                // 禁用或已选中
                if (this.invoiceTypeBtnIsDisabled(val) || this.invoiceRadio === val || this.invoiceModify === '0') {
                    return;
                }
                this.invoiceRadio = val;
                // 发票类型选择
                this.invoiceTypeSel();
            },
            // 发票类型选择
            invoiceTypeSel() {
                // 没开票抬头 但又不是不开票 不执行
                if (this.invoiceInfoList.length === 0 && this.invoiceRadio !== '0') {
                    this.invoiceRadio = '';// 去掉选中状态
                    return;
                }
                // 默认的开票类型
                let oldInvoiceInfoZh = '';
                // 默认开票值
                let defaultInvoiceVal = '';
                if (this.confirmFeeData.defaultInvoiceType === '1') {// 电子发票
                    oldInvoiceInfoZh = this.$t('message.electronicInvoice');
                    defaultInvoiceVal = '2';
                } else if (this.confirmFeeData.defaultInvoiceType === '2') {// DEBIT NOTE
                    oldInvoiceInfoZh = 'DEBIT NOTE';
                    defaultInvoiceVal = '0';
                } else if (this.confirmFeeData.defaultInvoiceType === '3') {// 纸质发票
                    oldInvoiceInfoZh = this.$t('message.invoice');
                    defaultInvoiceVal = '1';
                }
                // 修改后的开票类型
                let currentInvoiceInfoZh = '';
                if (this.invoiceRadio === '0') {// DEBIT NOTE
                    currentInvoiceInfoZh = 'DEBIT NOTE';
                } else if (this.invoiceRadio === '1') {// 纸质发票
                    currentInvoiceInfoZh = this.$t('message.invoice');
                } else if (this.invoiceRadio === '2') {// 电子发票
                    currentInvoiceInfoZh = this.$t('message.electronicInvoice');
                }

                if (this.confirmFeeData.defaultInvoiceType === '0') {// 无默认值
                    this.$Confirm({
                        msg: this.$t('message.pleaseConfirmAgainChooseCarefully'),
                        callback: () => {
                            // 发票类型切换操作
                            this.invoiceTypeSelChange();
                        },
                        cancel: () => {
                            // 初始化
                            this.invoiceRadio = this.invoiceRadioOld;
                            // 发票类型切换操作
                            this.invoiceTypeSelChange();
                        }
                    });

                } else if (this.confirmFeeData.defaultInvoiceType === '1') {// 电子发票
                    // 切换发票类型提示
                    this.changeInvoiceTypeHint(defaultInvoiceVal, oldInvoiceInfoZh, currentInvoiceInfoZh);
                } else if (this.confirmFeeData.defaultInvoiceType === '2') {// DEBIT NOTE
                    // 切换发票类型提示
                    this.changeInvoiceTypeHint(defaultInvoiceVal, oldInvoiceInfoZh, currentInvoiceInfoZh);
                } else if (this.confirmFeeData.defaultInvoiceType === '3') {// 纸质发票
                    // 切换发票类型提示
                    this.changeInvoiceTypeHint(defaultInvoiceVal, oldInvoiceInfoZh, currentInvoiceInfoZh);
                }
            },
            // 切换发票类型提示
            changeInvoiceTypeHint(defaultInvoiceVal, oldInvoiceInfoZh, currentInvoiceInfoZh) {
                if (this.invoiceRadio !== defaultInvoiceVal) {// 判断非默认开票值
                    this.$Confirm({
                        dangerouslyUseHTMLString: true,
                        msg: this.$t('message.yourCompanyHasAlwaysInvoicedType') + this.$t('message.$space') + '<b>' + oldInvoiceInfoZh + '</b>' + this.$t('message.$comma') + this.$t('message.isThisInvoiceTypeDeterminedToBeChangedTo') + this.$t('message.$space') + '<b>' + currentInvoiceInfoZh + '</b>' + this.$t('message.$qm') + this.$t('message.$space') + this.$t('message.pleaseConfirmAgainChooseCarefully'),
                        callback: () => {
                            // 发票类型切换操作
                            this.invoiceTypeSelChange();
                        },
                        cancel: () => {
                            // 初始化到上一次的开票值
                            this.invoiceRadio = this.invoiceRadioOld;
                            // 发票类型切换操作
                            this.invoiceTypeSelChange();
                        }
                    });
                } else {// 切回到默认开票值选项不需要弹窗提示
                    // 发票类型切换操作
                    this.invoiceTypeSelChange();
                }
            },
            // 发票类型切换操作
            invoiceTypeSelChange() {
                // 没开票抬头 但又不是不开票 不执行
                if (this.invoiceInfoList.length === 0 && this.invoiceRadio !== '0') {
                    this.invoiceRadio = '';// 去掉选中状态
                    return;
                }

                if (this.invoiceRadio === '0') {// 不开票
                    // 需交保函标志
                    this.invalidSign = '';
                    // 隐藏开票的详细信息
                    this.submitInvoiceBdMod = false;
                    // 开票信息详情数据
                    this.invoiceInfoItemData = {};
                    // 纸质发票提示
                    this.invoiceHintsMod = false;
                } else if (this.invoiceRadio === '1') {// 纸质发票
                    // 显示开票的详细信息
                    this.submitInvoiceBdMod = true;
                    // 模拟点击option的第一项
                    this.invoiceTitSelect(this.invoiceInfoIndex);
                    // 纸质发票提示
                    this.invoiceHintsMod = true;
                } else if (this.invoiceRadio === '2') {// 电子发票
                    // 显示开票的详细信息
                    this.submitInvoiceBdMod = true;
                    // 模拟点击option的第一项
                    this.invoiceTitSelect(this.invoiceInfoIndex);
                    // 纸质发票提示
                    this.invoiceHintsMod = false;
                }

                // 显示底部确定按钮
                this.submitInvoiceFtMod = true;
                
            },
            // 展开更多点击
            expandMoreClick() {
                // 纸质发票按钮模块显示
                this.paperInvoiceMod = true;
                // 展开更多隐藏
                this.expandMoreMod = false;
                // 大数据
                this.$bigData('expandMore', '展开更多', '1');
            },
            // 确认费用并提交开票按钮点击
            confirmAndSubmitClick() {
                // 判断开票信息是否有效
                if (this.invalidSign === '1') {// 需交保函
                    this.$Alert({msg: this.$t('message.guaranteePrompt')});
                    return;
                }
                if (this.invoiceRadio === '2') {// 电子发票
                    // 邮箱验证正则
                    let emailReg = this.$store.state.Regular.email;
                    // 财务邮箱验证通过 发送ajax
                    if (this.financialMail === '') {// 财务邮箱为空
                        this.$Alert({msg: this.$t('message.pleaseEnterFinancialEmail')});
                    } else {// 财务邮箱不为空
                        if (emailReg.test(this.financialMail)) {// 财务邮箱验证通过
                            // 判断开票限制标志【合并】
                            this.mergeInvoiceLimitDetermine();
                        } else {
                            this.$Alert({msg: this.$t('message.financialEmailEnterErr')});
                        }
                    }

                } else {
                    // 判断开票限制标志【合并】
                    this.mergeInvoiceLimitDetermine();
                }

            },
            // 判断开票限制标志【合并】
            mergeInvoiceLimitDetermine() {
                if (this.invoiceLimit === '1') {
                    this.$Alert({
                        msg: this.$t('message.currentNotInvoicePrompt'),
                        callback: () => {
                            // 调用确认提交开票ajax
                            this.confirmAndSubmitAjax();
                        }
                    });
                } else {
                    // 调用确认提交开票ajax
                    this.confirmAndSubmitAjax();
                }
            },
            // 确认费用并提交开票按钮Ajax
            confirmAndSubmitAjax() {
                // 深度拷贝 开票信息参数
                let invoiceInfoItemDataParams = JSON.parse(JSON.stringify(this.invoiceInfoItemData));
                switch (this.invoiceRadio) {
                    case '1':
                        // 删除是否有效的标志位（需交保函标志位）
                        delete invoiceInfoItemDataParams.invalid;
                        break;
                    case '2':
                        // 删除是否有效的标志位（需交保函标志位）
                        delete invoiceInfoItemDataParams.invalid;
                        // 寄票联系信息
                        delete invoiceInfoItemDataParams.expressContactInfo;
                        // 寄票电话
                        delete invoiceInfoItemDataParams.expressPhone;
                        // 寄票联系人
                        delete invoiceInfoItemDataParams.expressContact;
                        break;
                }
                this.$ajax({
                    url: '/personalCenterHandler/operationCenter/cargoQuery/exportBusiness/CostConfirmHandler.ashx',
                    data: {
                        act: 'postSubmitConfirmFeeAndInvoiceData',
                        orderBillCode: this.actualBillsOrderBillCode,// 托单号
                        couponId: '',// 优惠券ID
                        invoiceType: this.invoiceRadio,// 开票类型 0-DEBIT NOTE、1-纸质发票、2-电子发票
                        financialMailbox: this.financialMail,// 财务邮箱
                        invoiceMerge: this.invoiceRadio === '2' ? (this.confirmFeeData.settlementMethod === '0' ? this.invoiceMerge : '0') : '',// 合并开票 1-合并开票（默认）、0-单独开票
                        autoWriteOff: this.preInvoicing === '1' ? this.autoWriteOff : '0',// 自动核销 0-N、1-Y（默认）
                        // 开票信息 若不开票 以下信息不发送
                        invoiceInfo: JSON.stringify(invoiceInfoItemDataParams)// 开票信息
                    },
                    beforeSend: () => {
                        // 页面回归最顶部
                        window.scrollTo(0, 0);
                        // 加载中添加
                        this.isShowLoading = true;
                    },
                    success: () => {
                        this.$Alert({
                            msg: this.$t('message.submitSuccess'),
                        });
                        this.actualBillShow = false;
                    },
                    complete: () => {
                        // 加载中添加
                        this.isShowLoading = false;
                    }
                });
            },
            // 单独开票选择
            independentInvoiceRadioSel() {
                this.$Confirm({
                    msg: '你确认此发票需要单独开票吗？',
                    cancel: () => {
                        this.invoiceMerge = '1';
                    }
                });
            },
            // 提交合并板的数据
            postMergeBoardData() {
                if (this.mergeBoardSourceId === '') {
                    this.$Alert({
                        msg: '请先选择要合并的板'
                    });
                    return;
                }
                if (this.mergeBoardSourceId === this.mergeBoardTargetId) {
                    this.$Alert({
                        msg: '要合并的板和当前板不能相同'
                    });
                    return;
                }                
                let sourceBoardList = this.boardList.filter(board => board.boardId === this.mergeBoardSourceId);
                if (sourceBoardList.length === 0) {
                    this.$Alert({
                        msg: '要合并的板不存在'
                    });
                    return;
                }
                let sourceBoard = sourceBoardList[0];
                if (sourceBoard.type === '2') {
                    this.$Alert({
                        msg: 'FREE板不能合并'
                    });
                    return;
                }

                this.$ajax({
                    url: '/AllocationBoardHandler/AllocationBoardHandler.ashx',
                    data: {
                        act: 'postMergeBoardData',// 提交合并板的数据
                        sourceBoardId: this.mergeBoardSourceId,// 源板ID
                        targetBoardId: this.mergeBoardTargetId,// 目标板ID
                    },
                    beforeSend: () => {
                        this.mergeBoardDialogLoading = true;
                    },
                    success: () => {
                        this.$Alert({
                            msg: '提交成功'
                        });
                        this.mergeBoardDialog = false;
                        this.getDateBoardAllocationData();
                    },
                    complete: () => {
                        this.mergeBoardDialogLoading = false;
                        
                    }
                });
            },
            openBookingSizeNoteDialog(orderBill) {
                this.sizeNoteList = [
                    {
                        pieces: '',
                        length: '',
                        width: '',
                        high: ''
                    }
                ];
                if (orderBill.sizeNote.length > 0) {
                    this.sizeNoteList = [
                        ...orderBill.sizeNote
                    ];
                }
                this.orderSizeNoteObj = orderBill;
                this.sizeRemarkIsShow = true;
            },
            recalculateVolume1() {
                let totalVolume = 0;
                let totalPieces = 0;
                for (let sizeNote of this.sizeNoteList) {
                    if (sizeNote.length !== '' && sizeNote.width !== '' && sizeNote.high !== '') {
                        let volume = Number((Number(sizeNote.length) / 100).toFixed(4)) * Number((Number(sizeNote.width) / 100).toFixed(4)) * Number((Number(sizeNote.high) / 100).toFixed(4));
                        if (sizeNote.pieces !== '') {
                            volume = volume * Number(sizeNote.pieces);
                        }
                        sizeNote.volume = volume.toFixed(3);
                        totalVolume += Number(volume.toFixed(3));
                    } else {
                        sizeNote.volume = '';
                    }

                    if (sizeNote.pieces !== '') {
                        totalPieces += Number(sizeNote.pieces);
                    }
                }
                if (totalVolume > 0) {
                    this.orderSizeNoteObj.volume = totalVolume.toFixed(3);
                } else {
                    this.orderSizeNoteObj.volume = '';
                }
                if (totalPieces > 0) {
                    this.orderSizeNoteObj.pieces = totalPieces.toFixed(0);
                } else {
                    this.orderSizeNoteObj.pieces = '';
                }
            },
            
            onLithiumBatteryDialog(order) {
                this.lithiumBatteryDialogOrderObj = order;
                this.lithiumBatteryDialogObj.PI965 = this.lithiumBatteryDialogOrderObj.batteryInfo.includes('PI965');
                this.lithiumBatteryDialogObj.PI966 = this.lithiumBatteryDialogOrderObj.batteryInfo.includes('PI966');
                this.lithiumBatteryDialogObj.PI967 = this.lithiumBatteryDialogOrderObj.batteryInfo.includes('PI967');
                this.lithiumBatteryDialogObj.PI969 = this.lithiumBatteryDialogOrderObj.batteryInfo.includes('PI969');
                this.lithiumBatteryDialogObj.PI970 = this.lithiumBatteryDialogOrderObj.batteryInfo.includes('PI970');

                this.lithiumBatteryDialog = true;
            },
            saveLithiumBatteryDialog() {
                let batteryInfo = [];
                if (this.lithiumBatteryDialogObj.PI965) {
                    batteryInfo.push('PI965');                    
                }
                if (this.lithiumBatteryDialogObj.PI966) {
                    batteryInfo.push('PI966');                    
                }
                if (this.lithiumBatteryDialogObj.PI967) {
                    batteryInfo.push('PI967');                    
                }
                if (this.lithiumBatteryDialogObj.PI969) {
                    batteryInfo.push('PI969');                    
                }
                if (this.lithiumBatteryDialogObj.PI970) {
                    batteryInfo.push('PI970');                    
                }
                this.lithiumBatteryDialogOrderObj.batteryInfo = batteryInfo;
                this.lithiumBatteryDialog = false;
            },
            onMakeWaybill(item) {
                let orderList = item.orderBillList.filter(orderBill => orderBill.checkBoxSelected);
                if (orderList.length === 0) {
                    this.$Alert({
                        msg: '请选择一条订单'
                    });
                    return;
                }
                if (orderList.length !== 1) {
                    this.$Alert({
                        msg: '只能选择一条订单'
                    });
                    return;
                }
                if (item.returnBoard !== '') {
                    this.$Alert({
                        msg: '已退板，不能制作运单'
                    });
                    return;
                }
     
   
                let order = orderList[0];
                if (new Date().getTime() > Number(item.latestTimeWaybill)) {
                    this.$Alert({
                        msg: '当前时间，已超过运单最晚制作时间，不能制作运单'
                    });
                    return;
                }
                if (!['1','2'].includes(order.orderStatus)) {
                    this.$Alert({
                        msg: '请先发送E-BOOKING'
                    });
                    return;
                }

                let routeUrl = this.$router.resolve({
                    path: '/personalCenter/PersonalCenterMain/operationCenter/cargoQuery/exportBusiness/makeBill/AirWaybillMain',
                    query: {
                        orderBillCode: order.orderBillCode
                    }
                });

                window.open(routeUrl.href, '_blank');
       
            },
            // 获取包板改期的数据
            getPackageBoardRescheduleData() {
                if (this.changeDateDialog.selectDate === null) {
                    this.$Alert({
                        msg: '请选择日期'
                    });
                    return;
                }
                
                this.$ajax({
                    url: '/AllocationBoardHandler/AllocationBoardHandler.ashx',
                    data: {
                        act: 'getPackageBoardRescheduleData',// 获取包板改期的数据
                        date: this.$moment(this.changeDateDialog.selectDate).format('YYYY-MM-DD')
                    },
                    beforeSend: () => {
                        this.changeDateDialog.errMsg = '';
                        this.changeDateDialog.boardList = [];
                        this.changeDateDialog.loading = true;
                    },
                    success: (res) => {
                        this.changeDateDialog.dateStr = this.$moment(this.changeDateDialog.selectDate).format('MM月DD日');
                        if (res.success.boardList.length === 0) {
                            this.changeDateDialog.errMsg = '该日期没有板';
                        }
                        else {
                            let boards = this.boardList.filter(board => board.orderBillList.some(orderBill => orderBill.orderBillCode === this.changeDateDialog.orderBill.orderBillCode));
                            this.changeDateDialog.boardList = res.success.boardList.map(board => {
                                return {
                                    ...board,
                                    currentBoard: boards.length > 0 && board.boardId === boards[0].boardId
                                };
                            });
                        }
                    },
                    complete: () => {
                        this.changeDateDialog.loading = false;
                    }
                    
                });
            },
            // 提交包板改期的数据
            postPackageBoardRescheduleData(idx) {
                let board = this.changeDateDialog.boardList[idx];
                if (this.changeDateDialog.orderBill.weight !== '') {
                    let weightTotal = Number(board.loadedWeight) + Number(this.changeDateDialog.orderBill.weight); 
                    // 板合计重量超过预警重量
                    if (weightTotal > 0 && Number(board.warningWeight) > 0 && weightTotal > Number(board.warningWeight)) {
                        this.$Confirm({
                            msg: `该板重量超过${board.warningWeight}，请联系客服提前报备，以免飞不掉`,
                            showCancelButton: false,
                            confirmButtonText: '知道了',
                            showClose: false,
                            callback: () => {
                                this.$ajax({
                                    url: '/AllocationBoardHandler/AllocationBoardHandler.ashx',
                                    data: {
                                        act: 'postPackageBoardRescheduleData',// 提交包板改期的数据
                                        boardId: board.boardId,// 板ID
                                        orderBillCode: this.changeDateDialog.orderBill.orderBillCode,// 托单号
                                    },
                                    beforeSend: () => {
                                        this.changeDateDialog.loading = true;
                                    },
                                    success: () => {
                                        this.$Alert({
                                            msg: '移动成功',
                                        });
                                        this.$bigData('包板订单改期','包板订单改期',`托单号:${this.changeDateDialog.orderBill.orderBillCode}  运单号: ${this.changeDateDialog.orderBill.drCode} 改到板 ${board.boardId}`);
                                        this.changeDateDialog.visible = false;
                                        this.getDateBoardAllocationData();
                                        this.reReadCalendarDate();
                                        
                                    },
                                    complete: () => {
                                        this.changeDateDialog.loading = false;
                                    }
                                });
                            }
                        });
                        return;
                    }
                }
                
                
                this.$ajax({
                    url: '/AllocationBoardHandler/AllocationBoardHandler.ashx',
                    data: {
                        act: 'postPackageBoardRescheduleData',// 提交包板改期的数据
                        boardId: board.boardId,// 板ID
                        orderBillCode: this.changeDateDialog.orderBill.orderBillCode,// 托单号
                    },
                    beforeSend: () => {
                        this.changeDateDialog.loading = true;
                    },
                    success: () => {
                        this.$Alert({
                            msg: '移动成功',
                        });
                        this.$bigData('包板订单改期','包板订单改期',`托单号:${this.changeDateDialog.orderBill.orderBillCode}  运单号: ${this.changeDateDialog.orderBill.drCode} 改到板 ${board.boardId}`);
                        this.changeDateDialog.visible = false;
                        this.getDateBoardAllocationData();
                        this.reReadCalendarDate();
                        
                    },
                    complete: () => {
                        this.changeDateDialog.loading = false;
                    }
                });
            },
            reReadCalendarDate() {
                let date1 = this.$moment(Number(this.dateList[0].date)).format('YYYY-MM-DD');
                let date2 = this.$moment(Number(this.dateList[this.dateList.length - 1].date)).format('YYYY-MM-DD');
                this.$ajax({
                    url: '/AllocationBoardHandler/AllocationBoardHandler.ashx',
                    name: 'reReadCalendarAbort',
                    data: {
                        act: 'getUserBoardCalendarData',// 获取用户包板日历的数据
                        startDate: date1, // 开始日期（可传空）
                        endDate: date2, // 结束日期（可传空）
                    },
                    success: (res) => {
                        for (let i = 0; i < res.success.dateList.length; i++) {
                            for (let j = 0; j < this.dateList.length; j++) {
                                if (res.success.dateList[i].date === this.dateList[j].date) {
                                    this.dateList[j] = res.success.dateList[i];
                                }
                            }
                        }
                        
                    }
                });
            },
            
        }
    };
</script>
<style>
    .AllocationBoard_boardDetail_endPort_autocomplete {
        width: 80px !important;
    }
    .AllocationBoard_boardDetail_operationsCompany_autocomplete {
        //width: 80px !important;
    }
    .actualCostConfirm {
        width: 1100px !important;
    }
</style>
<style scoped lang="scss">
    .AllocationBoard {
        box-sizing: border-box;
        width: 1024px;
        margin-left: auto;
        margin-right: auto;
        margin-top: 50px;
        transform: translateX(-21px);
        .top_row {
            display: flex;
            justify-content: space-between;
            align-items: center;
            margin-bottom: 26px;
            margin-left: 43px;

            .airlineName {
                height: 25px;
                font-size: 18px;
                font-weight: 500;
                color: #4D4D4D;
            }

            .iconGroup {
                height: 16px;
                font-size: 12px;
                color: #4D4D4D;
                line-height: 16px;
                display: flex;
                align-items: center;

                > * {
                    margin-left: 5px;
                }
            }


        }

        .boardCalendarWrap {
            box-sizing: inherit;
            width: 100%;
            //height: 80px;
            margin-bottom: 12px;
            display: flex;
            align-items: flex-start;
            justify-content: space-between;

            .calendarSwiper {
                display: flex;
                flex-direction: row;

                .dateSwiper-button {
                    box-sizing: border-box;
                    width: 43px;
                    line-height: 90px;
                    height: 90px;
                    cursor: pointer;
                    display: flex;
                    align-items: center;

                    i {
                        width: 8px;
                        height: 14px;
                    }
                }

                .dateSwiper-prev i {
                    margin-left: 22px;
                }

                .dateSwiper-next i {
                    margin-left: 17px;
                }

                .dateSwiper {
                    position: relative;
                    box-sizing: border-box;
                    height: 90px;
                    display: flex;
                    flex-direction: row;
                    justify-content: space-between;
                    width: 100%;

                    font-size: 12px;
                    color: #4D4D4D;
                    background: #EEEEEF;

                    .dateTitle {
                        width: 100%;
                        text-align: center;
                        height: 16px;
                        line-height: 16px;
                        margin-top: 7px;
                    }

                    .dateDetail {
                        text-align: center;
                        color: #5F5F5F;
                        margin-top: 14px;
                        line-height: 16px;
                        display: flex;
                        align-items: center;
                    }

                    .overlay {
                        position: absolute;
                        top: 0;
                        left: 0;
                        width: 100%;
                        height: 100%;
                        background-color: rgba(0, 0, 0, 0.5); /* 这里的颜色和透明度可以根据需要进行调整 */
                        z-index: 1; /* 确保遮罩位于内容之上 */
                    }
                }

                .swiper-container {
                    width: 818px;
                    margin: 0 auto;
                    box-sizing: border-box;
                }
            }

            .calendarWrap {
                margin-left: 43px;
                position: relative;


                .dateCell {
                    box-sizing: border-box;
                    padding-left: 17px;
                    padding-top: 7px;
                    font-size: 12px;
                    height: 100%;

                    .dateTitle {
                        color: #4D4D4D;
                        height: 16px;
                        line-height: 16px;
                        margin-bottom: 8px;
                        text-align: left;
                    }

                    .dateDetail {
                        display: flex;
                        line-height: 16px;
                        color: #5F5F5F;
                    }
                }
                
                /deep/ .el-calendar-day {
                    padding: 0;
                }

                /deep/ .el-calendar__header {
                    display: none;
                }

                /deep/ .el-calendar__body {
                    padding: 0;
                }

            }

            .calendarBtn {
                width: 60px;
                height: 80px;
                display: flex;
                flex-direction: column;
                justify-content: center;
                align-items: center;
                background: #F5F5F5;
                cursor: pointer;
            }

            .active {
                border: 1px solid #0097E0 !important;
                //background-color: #EBF4FF;
            }
            .today {
                background-color: #F2F8FE !important;
                color: #4CA0FB !important;
            }

            .green {
                background-color: #E9EEDE !important;
            }

            .red {
                background-color: #D5BEBE !important;
            }

            .white {
                background-color: #FFFFFF !important;
            }
            
            .gray {
                background-color: #969696 !important;
            }
            
            .overlay {
                position: absolute;
                top: 0;
                left: 0;
                width: 100%;
                height: 100%;
                background-color: rgba(0, 0, 0, 0.5); /* 这里的颜色和透明度可以根据需要进行调整 */
                z-index: 1; /* 确保遮罩位于内容之上 */
                cursor: default;
            }
        }

        .boardTips {
            height: 16px;
            width: 690px;
            font-size: 12px;
            color: #4D4D4D;
            line-height: 16px;
            margin-bottom: 21px;
            margin-left: 43px;
            display: flex;
            flex-direction: row;
            justify-content: space-between;
            align-items: center;
        }

        .hr {
            width: 980px;
            border-bottom: 1px dashed #979797;
            margin-left: 43px;
        }

        .gapTotal {
            box-sizing: inherit;
            min-width: 582px;
            width: max-content;
            height: 46px;
            background: #F5F5F5;
            margin-top: 20px;
            padding: 10px 55px 10px 10px;
            display: flex;
            align-items: center;
            margin-left: 43px;
            >i {
                height: 21px;
                line-height: 21px;
                margin-right: 5px;
                cursor: pointer;
            }
            > div:first-child {
                height: 25px;
                font-size: 18px;
                font-weight: 500;
                color: #4D4D4D;
                line-height: 25px;
                margin-right: 13px;
            }

            > div:not(:first-child) {
                height: 21px;
                font-size: 16px;
                color: #4D4D4D;
                line-height: 21px;
                margin-right: 16px;
                display: flex;
                align-items: center;

                > img {
                    margin-left: 4px;
                    cursor: pointer;
                }
            }

            > div:last-child {
                margin-right: 0;
            }
        }

        .portAreaWrap {
            margin-top: 32px;
            margin-left: 43px;
            margin-bottom: 50px;

            .portAreaBtn {
                width: 118px;
                height: 32px;
                background: #F5F5F5;
                border-radius: 2px;
                display: flex;
                align-items: center;
                justify-content: center;
                cursor: pointer;

                > img {
                    width: 16px;
                    height: 16px;
                }

                > span {
                    font-size: 14px;
                    color: #4D4D4D;
                    margin-left: 2px;
                }
            }
            
            .showMiscellaneousFeeList {
                margin-left: 20px;
                font-size: 14px;
                width: 118px;
                height: 32px;
                line-height: 32px;
                color: #4D4D4D;
                background: #F5F5F5;
                text-align: center;
                cursor: pointer;

                .text {
                    cursor: pointer;
                }
            }
            
            .precautionsBtn {
                margin-left: 20px;
                font-size: 14px;
                width: 118px;
                height: 32px;
                line-height: 32px;
                color: #4D4D4D;
                background: #F5F5F5;
                text-align: center;
                cursor: pointer;
            }
            
            .flightCode {
                margin-left: 20px;
                font-size: 14px;
                height: 32px;
                line-height: 32px;
                color: #4D4D4D;
            }

            .portAreaContainer {
                width: 576px;
                margin-top: 8px;
                margin-bottom: 10px;
            }

            .boardDataWrap {
                margin-top: 40px;
                //margin-left: 43px;
                width: 980px;
                min-height: 303px;

                .boardDetailWrap {
                    margin-top: 21px;

                    .boardInfo {
                        display: flex;
                        align-items: center;
                        justify-content: space-between;
                        height: 21px;
                        font-size: 16px;
                        color: #4D4D4D;
                        line-height: 21px;
                        white-space: nowrap;

                        .left {
                            display: flex;
                            align-items: center;
                            
                            .item {
                                display: flex;
                                align-items: center;
                                margin-right: 24px;
                                
                                &:last-of-type {
                                    margin-right: 0;
                                }

                                .title {
                                    margin-right: 5px;
                                }
                                
                                /deep/.el-input__inner {
                                    padding: 0 8px;
                                }
                            }
                            
                            .red {
                                color: red;
                                cursor: pointer;
                            }
                        }
                        .right {
                            display: flex;
                            align-items: center;
                            
                 
                            
                            .mergeBoardBtn,.makeWaybillBtn {
                                display: flex;
                                align-items: center;
                                cursor: pointer;
                                margin-left: 36px;
                                
                                >img {
                                    width: 16px;
                                    height: 16px;
                                }
                                >span {
                                    margin-left: 3px;
                                    font-size: 14px;
                                    line-height: 19px;
                                    color: #707070;
                                }
                            }

                            .makeWaybillBtn {
                                margin-left: 0;
                            }
                            
                            .returnBoardBtn {
                                display: flex;
                                align-items: center;
                                cursor: pointer;
                                margin-left: 36px;
                                
                                >img {
                                    width: 16px;
                                    height: 16px;
                                }
                                >span {
                                    margin-left: 3px;
                                    font-size: 14px;
                                    line-height: 19px;
                                    color: #707070;
                                }
                            }
                        }

                       
                    }

                    .boardDetail {
                        margin-top: 26px;
                        border-bottom: 1px dashed #979797;
                        position: relative;
                        .isAbled {
                            background-color: white
                        }
                        .isDisabled{
                            background-color: #F5F7FA;
                            border-color: #E4E7ED;
                            color: #C0C4CC;
                        }

                        /deep/ .el-checkbox__inner {
                            width: 18px;
                            height: 18px;
                        }

                        /deep/ .el-checkbox__inner::after {
                            height: 10px;
                            left: 6px;
                        }
                        /deep/.el-input__inner {
                            padding: 0 3px;
                        }
                    }

                    .boardReduce {
                        display: flex;
                        align-items: center;
                        justify-content: space-between;
                        margin-top: 20px;

                        .reduceInfo {
                            display: flex;
                            align-items: center;
                            font-size: 16px;
                            height: 21px;
                            line-height: 21px;

                            > button {
                                color: #979797;

                            }
                        }
                    }

                    .tips {
                        margin-top: 15px;
                        font-size: 12px;
                        color: #4D4D4D;
                        margin-bottom: 16px;


                        > div {
                            height: 17px;
                            line-height: 17px;
                        }

                        > div:not(:last-child) {
                            margin-bottom: 3px;
                        }
                    }

                    .latestTimeTips {
                        height: 17px;
                        font-size: 12px;
                        font-weight: 400;
                        color: #409EFF;
                        line-height: 17px;
                    }
                    
                    .ebookingArea {
                        
                        .countdownGroup {
                            height: 17px;
                            font-size: 12px;
                            font-weight: 400;
                            color: #409EFF;
                            line-height: 17px;
                            display: flex;
                            align-items: center;
         

                            //.countdown {
                            //    width: 62px;
                            //    height: 48px;
                            //    font-size: 36px;
                            //    line-height: 48px;
                            //    color: #d0021b;
                            //    text-align: center;
                            //    background-color: white;
                            //}
                            //
                            //.colon {
                            //    width: 20px;
                            //    font-size: 25px;
                            //    color: white;
                            //    text-align: center;
                            //}
                            
                            
                        }
                        
                        >button {
                            margin-top: 3px;
                        }
                    }

                }

            }
        }


    }

    .gapDetailDialog {
        margin-left: 13px;
        margin-right: 13px;

        .title {
            height: 25px;
            color: #4D4D4D;
            font-size: 18px;
            font-weight: 500;
            line-height: 25px;

            > div {
                text-align: center;
            }
        }

        .detail {
            margin-top: 19px;
            border-bottom: 1px dashed #979797;

            color: #4D4D4D;
            font-size: 16px;
            line-height: 21px;

            /deep/ .columnClass {
                font-size: 16px;
                line-height: 21px;
                color: #4D4D4D;
            }
            

            .red {
                color: #FF0000;
            }

            .green {
                color: #6CA100;
            }
        }
    

        .reduce {
            height: 21px;
            line-height: 21px;
            text-align: right;
            font-size: 16px;
            margin-top: 16px;
            margin-right: 73px;
        }
    }

    .sizeRemarkDialog {
        .sizeNoteWrapper {
            margin-left: 56px;

            .sizeNote {
                display: flex;
                flex-direction: row;
                align-items: center;
                border-bottom: 1px solid #E0E0E0;
                padding-bottom: 8px;
                padding-top: 8px;
                width: 379px;
                
        

                .sizeNoteInput {
                    width: 60px;
                    height: 32px;
                    box-sizing: border-box;
                    border: 1px solid #DCDFE6;
                    padding-left: 12px;
                    font-size: 12px;
                    color: #000000;
                    line-height: 32px;
                }

                .sizeNoteSpan {
                    display: inline-block;
                    width: 80px;
                    height: 32px;
                    box-sizing: border-box;
                    font-size: 12px;
                    color: #000000;
                    line-height: 32px;
                    text-align: center;
                }

                .deleteOperate {
                    width: 20px;
                    height: 20px;
                    font-size: 20px;
                    display: flex;
                    color: #808080;
                    margin-left: 12px;
                    cursor: pointer;
                }
            }

            .sizeNoteAdd {
                display: flex;
                flex-direction: row;
                align-items: center;
                font-size: 20px;
                color: #8A8A8A;
                margin-top: 9px;
                cursor: pointer;
                width: 60px;
            }

            .sizeNoteEnter {
                display: flex;
                justify-content: center;
                align-items: center;
                margin-top: 26px;
                
                >button {
                    border-color: #4D4D4D;
                    width: 68px;
                    height: 30px;
                    border-radius: 4px;
                }
            }
        }
    }

    #QBSecondPassInformation {
        padding: 15px;
        border-top: 1px dashed #808080;
        position: relative;
        /*background-color: rgba(160,211,235,0.1);*/
        background-color: #FAFAFA;
        min-height: 63px;
    }

    #QBSecondPassInformation #QBInfoHead {
        display: flex;
        flex-direction: row;
        justify-content: space-between;
        align-items: flex-start;
        cursor: pointer;

    }

    #QBSecondPassInformation #QBInfoHead .firsttitle {
        color: #1a1a1a;
        font-size: 16px;
        line-height: 32px;
        font-weight: 600;
    }
    #QBSecondPassInformation #QBInfoHead .secondtitle {

    }
    #QBSecondPassInformation #QBInfoHead #QBInfoHead_left {
        display: flex;
        flex-direction: row;

    }
    #QBSecondPassInformation #QBInfoHead #QBInfoHead_left > div {
        margin-right: 48px;
    }

    #QBSecondPassInformation #QBInfoHead #QBInfoHead_right .conditionalSearchTit {
        margin: 0 10px 0 0;
    }

    #QBSecondPassInformation #QBInfoHead #QBInfoHead_right .icon-xia {
        /*color: #29abe2;*/
        display: inline-block;
        animation: switchBtnAniBot 0.7s infinite alternate;
        margin-right: 5px;
    }

    #QBSecondPassInformation #QBInfoHead #QBInfoHead_right .icon-shang {
        /*color: #29abe2;*/
        display: inline-block;
        animation: switchBtnAniTop 0.7s infinite alternate;
        margin-right: 5px;
    }
    #QBSecondPassInformation #QBInfoBody {
        /*margin-top: 30px;*/
        //display: none;
    }
    #QBSecondPassInformation #QBInfoBody #QBInfoBody_title {
        font-size: 14px;
        line-height: 32px;
        font-weight: 600;
        margin-top: 15px;
    }
    #QBSecondPassInformation #QBInfoBody #QBInfoBody_flightDetails .QBInfoBody_flightDetail {
        margin-top: 12px;
        font-size: 14px;
        line-height: 28px;
        color: #b3b3b3;
    }
    #QBSecondPassInformation #QBInfoBody #QBInfoBody_flightDetails .QBInfoBody_flightDetail .QBInfoBody_flightDetail_div1{
        display: flex;
        flex-direction: row;
        color: #1A1A1A;
    }

    #QBSecondPassInformation #QBInfoBody #QBInfoBody_flightDetails .QBInfoBody_flightDetail .QBInfoBody_flightDetail_div1 .QBInfoBody_flightDetail_div1_port{
        width: 170px;
    }
    #QBSecondPassInformation #QBInfoBody #QBInfoBody_flightDetails .QBInfoBody_flightDetail .QBInfoBody_flightDetail_div1 .QBInfoBody_flightDetail_div1_flight{
        display: flex;
        align-items: center;
        width: 180px;
    }

    #QBSecondPassInformation #QBInfoBody #QBInfoBody_flightDetails .QBInfoBody_flightDetail .QBInfoBody_flightDetail_div1 .QBInfoBody_flightDetail_div1_flight > span:nth-of-type(2) {
        color: #b3b3b3;

    }
    #QBSecondPassInformation #QBInfoBody #QBInfoBody_flightDetails .QBInfoBody_flightDetail_div1 > div {
        /*margin-right: 71px;*/

    }
    
    .miscellaneousFeeListWrap {
        position: relative;

        .btnBox {
            margin-top: 20px;
            text-align: right;
        }
    }

    .actualAfklcargoInformation {
        
        .iframeWrap {
            iframe {
                height: 600px;
            }
        }
    }

    /deep/ .el-table .cell {
        padding-left: 0;
        padding-right: 0;
    }

    .portAreaContainer /deep/ .el-table td {
        border-bottom: 1px dashed #979797;
    }

    .portAreaContainer /deep/ .el-table::before {
        background: none;
    }

    .boardDetail /deep/ .el-input__inner {
        border-radius: 0;
    }

    .boardDetail /deep/ .el-table td {
        border-bottom: none;
    }

    .boardDetail /deep/ .el-table::before {
        background: none;
    }


    #costConfirm {
        position: relative;
        width: 1070px;
        min-height: 600px;
        margin-bottom: 10px;
    }

    #bookSpaceInfo /deep/ .el-table th {
        background-color: #e6e6e6;
    }

    #costConfirm .costConfirmBd {
        width: 1054px;
        margin: 30px auto 0;
        //border-top: 1px dashed #595757;
    }

    .billGroup {
        padding-bottom: 30px;

        .billGroupItem {
            width: 1020px;
            margin: 0 auto;
        }

        .estimatedBill {
            .itemBd {
                padding: 20px;

                .costList {
                    .unitPrice {
                        position: relative;

                        .oldSettleUnit {
                            position: absolute;
                            right: 25px;
                            color: #b5b5b6;
                            text-decoration: line-through;
                        }
                    }
                }

                .insuranceFee {
                    margin: 40px 0 0 0;

                    /deep/ .el-table {
                        th {
                            color: #00a0e9;
                        }

                        td {
                            color: #727171;
                            border-bottom: 1px solid transparent;
                        }

                        &::before {
                            height: 0;
                        }
                    }
                }
            }
        }

        .realBill {
            .itemBd {
                position: relative;

                .unsubscribeImg {
                    position: absolute;
                    top: 0;
                    left: 210px;
                    z-index: 1;
                }
            }
        }

        .itemHd {
            margin: 28px 0 12px 0;
            font-size: 18px;
            color: #3e3a39;

            .title {
                font-size: 18px;
                color: #3e3a39;
            }

            .currency {
                margin: 0 0 0 20px;
                font-size: 16px;
                color: #898989;
            }
        }

        .itemBd {
            position: relative;
            min-height: 200px;
            padding: 20px;
            box-shadow: 0 0 6px 0 rgba(0, 0, 0, 0.15);

            /deep/ .el-table {
                th {
                    color: #00a0e9;
                    border-bottom: 1px dashed rgba(0, 160, 233, 0.5);
                }

                td {
                    color: #727171;
                    border-bottom: none;
                }

                &::before {
                    height: 0;
                }
            }

            .tableBg {
                position: absolute;
                top: 30px;
                left: 14px;
                width: 230px;
                height: 206px;
                background-image: url("~@/assets/img/personalCenter/operationCenter/cargoQuery/exportBusiness/cargoFinanceManagementMain/realCostBg.png");
                background-size: cover;
            }

            .tableFt {
                margin: 16px 85px 10px 0;
                text-align: right;
                position: relative;
                right: 0;
                bottom: 0;

                .difference {
                    display: inline-block;
                    font-size: 16px;
                    color: #898989;

                    .txt {
                        font-size: 20px;
                        color: #e83828;
                    }
                }

                .total {
                    display: inline-block;
                    height: 46px;
                    padding: 0 20px;
                    margin-left: 26px;
                    font-size: 22px;
                    line-height: 46px;
                    color: #3e3a39;
                    text-align: center;
                    border: 1px solid rgba(178, 178, 178, 1);
                    border-radius: 23px;
                }

                .money {
                    font-size: 25px;
                    font-weight: bold;
                    color: #e83828;
                }

                .btnGroup {
                    display: flex;
                    align-items: center;
                    justify-content: flex-end;
                }
            }
        }
    }

    #preferentialWay {
        /* display: none; */
        width: 1020px;
        margin: 0 auto;
    }

    #preferentialWay .preferentialWayHd {
        margin: 28px 0 12px 0;
        font-size: 18px;
        color: #3e3a39;
    }

    #preferentialInfo {
        height: 68px;
        padding-left: 28px;
        font-size: 14px;
        line-height: 68px;
        color: #727171;
        box-shadow: 0 0 6px 0 rgba(0, 0, 0, 0.15);
    }

    #preferentialInfo .dynamic {
        color: #2ea7e0;
    }

    #preferentialInfo .clickSelect {
        margin: 0 0 0 20px;
    }

    #myCoupons {
        margin-top: 20px;
    }

    #myCoupons .myCouponsBd {
        border: 1px solid #727171;
    }

    #couponsList {
        margin: 25px 0 25px 34px;
        overflow: hidden;
    }

    #couponsList .couponsItem {
        position: relative;
        float: left;
        width: 180px;
        height: 180px;
        cursor: pointer;
        border: 3px solid transparent;
    }

    #couponsList .couponsItem.active {
        border: 3px solid #0094dd;
    }

    #couponsList .couponsItem .chosen {
        display: none;
    }

    #couponsList .couponsItem.active .chosen {
        position: absolute;
        top: 2px;
        right: 8px;
        display: inline-block;
        color: #0094dd;
    }

    #couponsList .couponsItem .couponsItemBg {
        width: 140px;
        height: 140px;
        margin: 20px;
        text-align: center;
        background-size: cover;
        border-radius: 50%;
        box-shadow: 5px 5px 20px rgba(0, 0, 0, 0.5);
    }

    #couponsList .couponsItem .couponsItemBg.freightVoucher {
        background-image: url("~@/assets/img/personalCenter/operationCenter/cargoQuery/exportBusiness/cargoFinanceManagementMain/freightVoucher.png");
    }

    #couponsList .couponsItem .couponsItemBg.relievedVoucher {
        background-image: url("~@/assets/img/personalCenter/operationCenter/cargoQuery/exportBusiness/cargoFinanceManagementMain/relievedVoucher.png");
    }

    #couponsList .couponsItem .couponsItemBg.operationVoucher {
        background-image: url("~@/assets/img/personalCenter/operationCenter/cargoQuery/exportBusiness/cargoFinanceManagementMain/operationVoucher.png");
    }

    #couponsList .couponsItem .couponsItemBg.carVoucher {
        background-image: url("~@/assets/img/personalCenter/operationCenter/cargoQuery/exportBusiness/cargoFinanceManagementMain/carVoucher.png");
    }

    #couponsList .couponsItem .couponsItemHd {
        width: 90px;
        padding-top: 36px;
        margin: 0 auto;
        font-size: 12px;
        color: #fff;
    }

    #couponsList .couponsItem .couponsItemBd {
        font-size: 26px;
        font-weight: bold;
        color: #fff;
    }

    #couponsList .couponsItem .couponsItemFt span {
        display: inline-block;
        width: 80px;
        height: 20px;
        font-size: 12px;
        line-height: 20px;
        background-color: #fff;
        border-radius: 2px;
    }

    #couponsList .couponsItem .couponsItemBg.freightVoucher .couponsItemFt span {
        color: #22aedd;
        border: 1px solid #22aedd;
    }

    #couponsList .couponsItem .couponsItemBg.relievedVoucher .couponsItemFt span {
        color: #8ec31f;
        border: 1px solid #8ec31f;
    }

    #couponsList .couponsItem .couponsItemBg.operationVoucher .couponsItemFt span {
        color: #f8b62b;
        border: 1px solid #f8b62b;
    }

    #couponsList .couponsItem .couponsItemBg.carVoucher .couponsItemFt span {
        color: #c9caca;
        border: 1px solid #c9caca;
    }

    #myCoupons .myCouponsFt {
        margin: 16px 0 0 0;
        font-size: 22px;
        color: #3e3a39;
        text-align: right;
    }

    #myCoupons .myCouponsFt .couponsTotal {
        display: inline-block;
        height: 46px;
        padding: 0 10px;
        line-height: 46px;
        text-align: center;
        border: 1px solid #727171;
    }

    #myCoupons .myCouponsFt .couponsTotal .money {
        font-size: 25px;
        font-weight: bold;
        color: #e83828;
    }

    #preferentialWay .preferentialWayFt {
        padding: 26px 0 20px 0;
        text-align: right;
    }

    #preferentialWay .preferentialWayFt .confirmMoney {
        font-size: 18px;
    }

    #submitInvoice {
        width: 1020px;
        padding: 0 17px 52px;
        margin: 0 auto;
        overflow: hidden;

        .submitInvoiceHd {
            margin: 22px 0 24px;

            .isSubmitInvoice {
                margin-bottom: 14px;
                font-size: 18px;
                color: #3e3a39;
            }

            .beforeNotInvoicePromptBox,
            .overtakeTenDayNotInvoicePromptBox {
                font-size: 14px;
                color: #e83828;
            }
        }
    }

    #submitInvoice .submitInvoiceHd .inputGroup {
        box-sizing: border-box;
        width: 1020px;
        padding-left: 35px;
        box-shadow: 0 0 6px 0 rgba(0, 0, 0, 0.15);

        .invoiceRadioGroup {
            position: relative;
            display: flex;
            padding: 20px 0;

            .invoiceTypeBtn {
                position: relative;
                padding: 5px 32px;
                margin-right: 35px;
                font-size: 18px;
                color: #00a0e8;
                cursor: pointer;
                border: 1px solid #00a0e8;
                border-radius: 4px;

                &.selected {
                    color: white;
                    background-color: #00a0e8;
                }

                &.disabled {
                    color: white;
                    cursor: not-allowed;
                    background-color: #c8c9cc;
                    border-color: #c8c9cc;
                }

                .icon-tuijian {
                    position: absolute;
                    top: -20px;
                    right: -23px;
                    font-size: 19px;
                    color: #e83828;
                }
            }

            .paperInvoice {
                display: none;

                .paperInvoiceModTip {
                    position: absolute;
                    top: 35px;
                    left: 5px;
                    width: 300px;
                    font-size: 12px;
                    line-height: 16px;
                    color: #e83828;
                }
            }

            .expandMore {
                position: absolute;
                top: 20px;
                right: 30px;
                display: none;
                line-height: 16px;
                color: #409eff;
                cursor: pointer;
            }
        }

        .invoiceMergeBox {
            margin-bottom: 20px;
            font-size: 16px;

            /deep/ .el-radio__label {
                font-size: 16px;
            }

            .invoiceMergeBoxTitle {
                margin-right: 20px;
            }

            label {
                margin-right: 20px;
            }
        }
    }

    .payTitle {
        margin-bottom: 22px;
        font-size: 16px;

        span {
            margin-right: 30px;
        }
    }

    .autoWriteOff {
        margin-bottom: 22px;

        .title {
            font-size: 16px;
        }

        .autoWriteOffSwitch {
            margin-right: 21px;
            margin-left: 13px;
        }

        .autoWriteOffTips {
            font-size: 14px;
            color: #9b9b9b;
        }
    }

    #submitInvoice .submitInvoiceHd .inputGroup .electronInvoiceTips {
        padding-bottom: 20px;
        line-height: 20px;
        color: #9b9b9b;
    }

    #submitInvoice .submitInvoiceHd .inputGroup input {
        width: 23px;
        height: 23px;
        margin: 0 12px 0 34px;
        vertical-align: middle;
    }

    #submitInvoice .submitInvoiceHd .inputGroup input[disabled] {
        cursor: not-allowed;
    }

    #submitInvoice .submitInvoiceHd .inputGroup input[disabled] + label {
        color: #ccc;
        cursor: not-allowed;
        user-select: none;
    }

    #submitInvoice .submitInvoiceHd .inputGroup label {
        margin: 0 80px 0 0;
        font-size: 18px;

        /* color: #00a0e9; */
        vertical-align: middle;
    }

    #submitInvoice .submitInvoiceHd .inputGroup label:first-child {
        margin-right: 0;
    }

    #submitInvoice .submitInvoiceBd .invoiceInfoHd {
        display: inline-block;
        margin-bottom: 26px;
        font-size: 16px;
        color: #3e3a39;

        /deep/ .el-select {
            width: 274px;
        }

        .invoiceName {
            margin-right: 12px;
        }

        > span {
            margin: 0 4px 0 0;
        }
    }

    #submitInvoice .invoiceHints {
        margin: 15px 0 0 0;
    }

    #submitInvoice .invoiceHints p {
        margin: 5px 0 0 0;
        font-size: 12px;
        color: red;
    }

    #invoiceInfo .financialMailbox {
        display: inline-block;
        margin-bottom: 26px;
        margin-left: 28px;
        font-size: 16px;

        /deep/ .el-input {
            width: 222px;
        }
    }

    #invoiceInfo .financialMailbox .financialMailTip {
        margin: 0 0 0 6px;
        font-size: 12px;
        color: #9b9b9b;
    }

    #invoiceInfo .financialMailbox > label {
        margin-right: 12px;
        color: #3e3a39;
    }

    #invoiceInfo .financialMailbox > input {
        width: 266px;
        height: 26px;
        padding: 0 5px;
        color: black;
    }

    #invoiceInfoDetail {
        display: flex;
        flex-wrap: wrap;
        overflow: hidden;
    }

    #invoiceInfoDetail .infoItem {
        display: flex;
        align-items: center;
        width: 305px;
        margin-bottom: 14px;
        font-size: 14px;
        color: #727171;

        &:nth-child(3n+2) {
            width: 375px;

            .invoiceInfoItemLabel {
                width: 134px;
            }
        }

        &:nth-child(3n) {
            margin-left: 30px;
        }

        .invoiceInfoItemLabel {
            /* 兼容ie10 */
            display: inline-block;
            width: 61px;
            margin-right: 10px;
            text-align: right;
            word-wrap: break-word;
        }
    }

    #invoiceInfoDetail .infoItem /deep/ {
        .el-input {
            width: auto;
            margin-left: 5px;
        }

        .el-input__inner {
            width: 224px;
        }
    }

    #submitInvoice .submitInvoiceFt {
        padding: 12px 0 0 0;
        text-align: right;

        /deep/ button {
            font-size: 18px;
        }
    }

    .goodsData /deep/ {
        .el-dialog__title {
            font-size: 16px;
        }

        .el-dialog {
            width: 780px;
            margin-top: 30vh !important;
        }

        .el-dialog__body {
            padding-top: 0;
        }
    }

    .goodsData .goodsDataTit {
        margin: 0 10px 10px;
        font-size: 16px;
        font-weight: bold;
        color: #e73828;
        text-align: center;
    }

    .goodsData .goodsDataBd {
        display: flex;
        align-items: center;
        justify-content: space-around;
        padding: 0 20px;
        overflow: hidden;

        p {
            margin: 6px 0;
        }

        tr td {
            padding: 5px 0;
        }
    }

    /* 方案弹窗 */

    .planTableDialog {
        .viewPlanTit {
            margin: 0 0 15px 0;
            font-size: 18px;
            color: #3e3a39;

            .currency {
                margin: 0 0 0 20px;
                font-size: 16px;
                color: #898989;
            }
        }

        .planBox {
            display: flex;
            justify-content: space-between;
            padding-bottom: 20px;

            .selectedBill,
            .notSelectedBill {
                width: 46%;
            }

            .planHd {
                font-size: 14px;
            }

            .selectedBillHd {
                color: #00a0e9;
            }

            .notSelectedBillHd {
                color: #898989;
            }

            .planBd {
                padding: 7px;
                margin: 6px 0 0 0;

                .bdBorder {
                    width: 100%;
                    padding-bottom: 8px;

                    .tit {
                        position: relative;
                        margin: 8px 0;
                        text-align: center;

                        > i {
                            font-size: 25px;
                            vertical-align: middle;
                        }

                        > span {
                            margin: 0 0 0 4px;
                            font-size: 16px;
                            vertical-align: middle;
                        }

                        .best {
                            position: absolute;
                            top: -24px;
                            margin: 0 0 0 15px;
                        }
                    }
                }
            }

            .selectedBillBd {
                background-color: rgba(0, 160, 233, 0.55);
                box-shadow: 2px 2px 5px rgba(62, 62, 62, 0.75);

                .bdBorder {
                    border: 1px dashed #fff;

                    .tit {
                        > i {
                            color: #fff;
                        }

                        > span {
                            color: #fff;
                        }
                    }

                    /deep/ .el-table {
                        th,
                        td {
                            color: #fff;
                            background-color: rgba(0, 160, 233, 0.55);
                            border-bottom: 1px solid transparent;
                        }

                        &::before {
                            height: 0;
                        }

                        .el-table__empty-block {
                            background-color: rgba(0, 160, 233, 0.55);
                        }
                    }
                }
            }

            .notSelectedBillBd {
                background-color: rgba(0, 160, 233, 0.15);

                .bdBorder {
                    border: 1px dashed #3e3a39;

                    .tit {
                        > i {
                            color: #00a0e9;
                        }

                        > span {
                            color: #00a0e9;
                        }
                    }

                    /deep/ .el-table {
                        th,
                        td {
                            color: #727171;
                            background-color: rgba(0, 160, 233, 0.15);
                            border-bottom: 1px solid transparent;
                        }

                        &::before {
                            height: 0;
                        }

                        .el-table__empty-block {
                            background-color: rgba(0, 160, 233, 0.15);
                        }
                    }
                }
            }

            .planFt {
                margin: 20px 0 0;
                text-align: right;

                .total {
                    display: inline-block;
                    height: 46px;
                    padding: 0 20px;
                    margin-left: 26px;
                    font-size: 22px;
                    line-height: 46px;
                    color: #3e3a39;
                    text-align: center;
                    border: 1px solid rgba(178, 178, 178, 1);
                    border-radius: 23px;

                    .totalBody {
                        display: flex;
                        align-items: center;
                    }
                }

                .money {
                    font-size: 25px;
                    font-weight: bold;
                    color: #e83828;
                }
            }
        }
    }

    /* 原预计账单弹窗 */

    .originalEstimatedBillDialog {
        .itemHd {
            padding: 0 20px;
            margin: 0;
            font-size: 18px;
            color: #3e3a39;

            .title {
                font-size: 18px;
                color: #3e3a39;
            }

            .currency {
                margin: 0 0 0 20px;
                font-size: 16px;
                color: #898989;
            }
        }

        .itemBd {
            position: relative;
            padding: 20px;

            /deep/ .el-table {
                th {
                    color: #00a0e9;
                    border-bottom: 1px dashed rgba(0, 160, 233, 0.5);
                }

                td {
                    color: #727171;
                    border-bottom: none;
                }

                &::before {
                    height: 0;
                }
            }

            .tableBg {
                position: absolute;
                top: 30px;
                left: 14px;
                width: 230px;
                height: 206px;
                background-image: url("~@/assets/img/personalCenter/operationCenter/cargoQuery/exportBusiness/cargoFinanceManagementMain/realCostBg.png");
                background-size: cover;
            }

            .insuranceFee {
                margin: 40px 0 0 0;

                /deep/ .el-table {
                    th {
                        color: #00a0e9;
                    }

                    td {
                        color: #727171;
                        border-bottom: 1px solid transparent;
                    }

                    &::before {
                        height: 0;
                    }
                }
            }

            .tableFt {
                margin: 16px 85px 0 0;
                text-align: right;

                .total {
                    display: inline-block;
                    height: 46px;
                    padding: 0 20px;
                    margin-left: 26px;
                    font-size: 22px;
                    line-height: 46px;
                    color: #3e3a39;
                    text-align: center;
                    border: 1px solid rgba(178, 178, 178, 1);
                    border-radius: 23px;

                    .totalBody {
                        display: flex;
                        align-items: center;
                    }
                }

                .money {
                    font-size: 25px;
                    font-weight: bold;
                    color: #e83828;
                }
            }
        }
    }

    .mergeBoardDialog {
        position: relative;
        margin-bottom: 10px;
        
        .row1 {
            display: flex;
            align-items: center;
            justify-content: center;
            
            
            
            >img {
                margin-left: 12px;
                margin-right: 36px;
            }

        }

        .buttonGroup {
            margin-top: 33px;
            display: flex;
            justify-content: center;
            align-items: center;
        }
    }
    
    .lithiumBatteryDialog {
        width: 418px;
        box-sizing: border-box;
        margin: 0 auto;
        margin-top: -30px;
        
        display: flex;
        flex-direction: column;
        align-items: center;
        
        >.title {
            height: 25px;
            font-size: 18px;
            font-weight: 500;
            color: #4D4D4D;
            line-height: 25px;
            margin-bottom: 20px;
        }
        
        >.content {
            margin-bottom: 24px;  
            margin-left: 36px;
            >*{
                margin-bottom: 12px;
                /deep/.el-checkbox__inner {
                    width: 18px;
                    height: 18px;
                }

                /deep/ .el-checkbox__inner::after {
                    height: 10px;
                    left: 6px;
                }
                /deep/.el-checkbox__label{
                    color: #4D4D4D;
                }
                /deep/.el-checkbox__input.is-checked+.el-checkbox__label {
                    color: #409EFF;
                }
                
                
                &:last-child {
                    margin-bottom: 0;
                }
            }  
        }
        
        >button {
            width: 68px;
            height: 30px;
            box-sizing: border-box;
            padding: 0;
            display: flex;
            justify-content: center;
            align-items: center;
            border: 1px solid #4D4D4D;
            border-radius: 4px;
            background-color: #FFFFFF;
            color: #4D4D4D;
            font-size: 14px;
        }
        
    }
    
    .precautionsDialog {
        display: flex;
        flex-direction: column;
        text-align: left;
        align-items: flex-start;
        gap: 12px;
        font-size: 16px;

        .btnBox {
            margin-top: 20px;
            text-align: right;
            align-self: flex-end;
        }
    }
    
    .changeDateDialog {
        width: 280px;
        box-sizing: border-box;
        margin: 0 auto;
        
        .row1 {
            display: flex;
            align-items: center;
            margin-bottom: 40px;
        }
        
        .row2 {
            margin-bottom: 20px;
            min-height: 160px;
            position: relative;
            
            .dateTitle {
                height: 25px;
                font-weight: bold;
                font-size: 18px;
                color: #4D4D4D;
                line-height: 25px;
                //text-decoration: underline 2px #4D4D4D;
                margin-bottom: 23px;
                padding-bottom: 4px;
                display: inline-block;
                border-bottom: 2px solid #4D4D4D;
            }
            .errMsg{
                height: 19px;
                font-size: 14px;
                color: #C9C9C9;
                line-height: 19px;
            }
            .boardList{
                font-size: 14px;
                color: #4D4D4D;
                
                .boardWrap {
                    margin-bottom: 20px;
                    height: 24px;
                    display: flex;
                    align-items: center;
                    
                    &:last-of-type{
                        margin-bottom: 0;
                    }
                    .boardName {
                        width: 100px;
                        margin-right: 3px;
                    }
                    
                    .weightData{
                        width: 100px;
                        margin-right: 12px;
                    }
                    
                }
                
            }
        }
    }

</style>